
global = window["srm"]["methodsMap"]
events = global["events"]

reactive = require('component-reactive')
cookie = require('component-cookie')
request = require('superagent')
slug = require('../boot/utils').slug
Hammer = require('hammerjs')
Tween = require('component-tween')  # see https://github.com/component/tween
raf = require('raf')  # see https://github.com/chrisdickinson/raf
textFlow = require('../boot/textflow')
d3 = require('d3')  # v4
# d3version = parseInt(d3.version, 10)
d3GetTransforrm = require('../boot/d3transform')
require('../boot/d3v4utils')(d3)


class MapView

    constructor: (@nodeName) ->

        if __DEV__
            debug = @debug or 0
            debug = @debug or 0
            if debug
                console.log('map-view.js')
                console.log('  @nodeName=', @nodeName)

        @rootKey = ''
        @slugMap = {}
        @titleContainer = document.querySelector('title')

        @mainRadius = 130
        @ellipses = '...'

        @refCountTries = 0
        @refCountTimeout = 10000  # in milliseconds
        @maxRefCountTries = 10

        @expandedView = false
        @maxNodes = 10

        @maxTextLength = global['maxTextLength']
        @maxMobileTextLength = global['maxMobileTextLength']

        @showRefCounts = false

        @resizedOnce = false
        #@history = ['', '', '', '', '', '']
        history = cookie('history')
        if history
            @history =  JSON.parse(history)
        else
            @history = ['', '', '', '', '', '']

        @broaderRadius = 80
        @broaderChildBubbleRingRadius = 150
        @broaderChildTextRingRadius = 170

        @narrowerRadius = 80
        @narrowerChildBubbleRingRadius = 150
        @narrowerChildTextRingRadius = 170

        @relatedRadius = 80
        @relatedChildBubbleRingRadius = 150
        @relatedChildTextRingRadius = 170

        @bubbleCount = 0

        @commasFormatter = d3.format(",.0f")

        #if __DEV__ or 1
        #    @debugTransitions = true
        @transitionDuration = 1000
        @transitionInProgress = false
        #if @debugTransitions
        #    console.log('  setting @transitionInProgress to', JSON.stringify(@transitionInProgress))

        #expression = 'meta[property="og:url"]'
        #@metaNode = document.querySelector(expression)
        #if not @metaNode
        #    console.error('unable to find node at ' + expression)

        expression = 'div.methods-map'
        @svgContainer = document.querySelector(expression)
        if not @svgContainer
            console.error('unable to find node at ' + expression)
        @aspectRatio = null

        require('./map-view.css')
        require('./map-view-svg.css')
        require('./map-view-html.css')

        @deviceWidth = null
        @defaultView = 'desktop'
        @currentView = @defaultView
        @activeAdjustTranslateList = []

        @browserHistory = true

        @refRequest = null

        @accessibilityMode = false

        @forceTabIndex = false

        if __DEV__
            window.d3 = d3
            window.focusBubble = @focusBubble
            window.focusNode = @focusNode
            window.transitionInProgress = @transitionInProgress
            window.resizeSVGNode = @resizeSVGNode
            window.toggleExpandedView = @toggleExpandedView

        @JSONURL = window['srm']["methodsMap"]["urls"]["json"]  # NOTE: /methods-map/json

        @addEvents()
        @initialize()

        return

    initialize: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('initialize()')

        @drawTemplate((svgNode) =>
            @setupHTMLNode()
            @setupSVGNode(svgNode)
            @setupSwipe()
            @setupChildNodes()
            @getData()
            @backupDefaultViews()
            @prepareVirtualBuffer()
            return
        )

        return

    addEvents: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('addEvents()')

        events.on('node:load', @focusNode)
        events.on('node:rendered', @getRefCounts)
        events.on('node:rendered', @updateShareThisURL)
        events.on('node:rendered', @centerNarrowerBubble)
        events.on('accessibility:toggle', @toggleAccessibityMode)
        events.on('definition:focus', @focusDefinition)
        events.on('map:ready', () =>
            @resize()
            @showHistory()
            return
        )
        events.on('window:resize', @resize)
        if document.createEvent
            @clickEvent = document.createEvent("MouseEvent");
            @clickEvent.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
            @tapEvent = document.createEvent("MouseEvent");
            @tapEvent.initMouseEvent('tap', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
        else
            @clickEvent = new MouseEvent('click', {
                'view': window
                'bubbles': true
                'cancelable': true
            })
            @tapEvent = new MouseEvent('tap', {
                'view': window
                'bubbles': true
                'cancelable': true
            })

        events.on('click', (node) =>
            node.dispatchEvent(@clickEvent)
            return
        )
        events.on('tap', (node) =>
            node.dispatchEvent(@tapEvent)
            return
        )
        events.on('svg:resize', @resizeSVGNode)
        if @browserHistory
            window.onpopstate = ((event) =>
                #
                # window.history
                #
                #console.log("location: " + document.location + ", state: " + JSON.stringify(event.state))
                if event.state
                    ref = event.state.ref
                else
                    ref = ''
                @focusNode(ref, {history: false})
                return
            )

        return

    prepareVirtualBuffer: () ->

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('prepareVirtualBuffer()')

        container = document.createElement('div')
        container.classList.add('virtualbuffer')
        @virtualBufferNode = document.createElement('input')
        @virtualBufferNode.setAttribute('type', 'hidden')
        @virtualBufferNode.setAttribute('value', '1')
        container.appendChild(@virtualBufferNode)
        document.body.appendChild(container)

        return

    updateVirtualBuffer: () ->

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('updateVirtualBuffer()')

        if @virtualBufferNode.getAttribute('value') is '1'
            @virtualBufferNode.setAttribute('value', '0')
        else
            @virtualBufferNode.setAttribute('value', '1')

        return

    updateShareThisURL: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('updateShareThisURL()')

        ref = @currentRef
        if not @nodeMap[ref]
            return
        name = @nodeMap[ref].name
        slug_name = slug(name)
        #url = location.href.replace(/\/$/, "") + '/' + slug_name
        url = location.origin.replace(/\/$/, "") + '/methods-map/' + slug_name
        #console.info('updateShareThisURL: name="' + name + '", slug_name="' + slug_name + '", url="' + url + '"')
        #if @metaNode
        #    @metaNode.setAttribute('content', url)
        if window.$
            try
                $('[st_url]').attr('st_url', url)
                $('#epURL').val(url)
            catch err
                console.error(err)

        return

    resizeSVGNode: () =>

        # NOTE: called from events.emit('svg:resize')
        if __DEV__
            debug = @debug or 0
            if debug or 0
                console.log('resizeSVGNode()')
                console.log('  @currentView=', @currentView)
                console.log('  @aspectRatio=', @aspectRatio)

        if @currentView is 'mobile'
            height = d3.select('g#template').node().getBBox().height
            height += 150  # padding
            if __DEV__
                if debug
                    console.log('  g#template height=', height)
            viewBoxValue = @svg.node().getAttribute('data-mobile-viewBox-template')
            if __DEV__
                if debug
                    console.log('  viewBoxValue=', viewBoxValue)
            viewBoxValue = viewBoxValue.replace('{height}', height)
            if __DEV__
                if debug
                    console.log('  viewBoxValue=', viewBoxValue)
        else
            viewBoxValue = @svg.node().getAttribute('data-backup-viewBox')
        if __DEV__
            if debug
                console.log('  viewBoxValue=', viewBoxValue)
        viewBox = viewBoxValue.split(" ")
        if __DEV__
            if debug
                console.log('  viewBox=', viewBox)
        width = viewBox[2]
        height = viewBox[3]
        if not @aspectRatio
            @aspectRatio = width / height
            if __DEV__
                if debug
                    console.log('  @aspectRatio=', @aspectRatio)
        current_container_width = @svgContainer.clientWidth
        current_container_height = @svgContainer.clientHeight
        if __DEV__
            if debug
                console.log('  current_container_width=', current_container_width)
                console.log('  current_container_height=', current_container_height)
        factor = current_container_width / width
        if __DEV__
            if debug
                console.log('  factor=', factor)
        #height = current_container_width * @aspectRatio
        if __DEV__
            if debug
                console.log('  height=', height)
        height *= factor
        if __DEV__
            if debug
                console.log('  height (after factor)=', height)
                console.log('  width=', width)
        #alert('resize height from ' + @svgContainer.style.height + ' to ' + height + ', svg width is ' + current_container_width)
        if not @resizedOnce
            #@svg.attr('opacity', 1)
            @svg.node().style.opacity = 1
        @resizedOnce = true
        @svg.classed('invisible', false)
        if 1
            @svg.attr('viewBox', viewBoxValue)
            @svg.node().style.height = height + 'px'
            #@svg.node().style.width = current_container_width + 'px'
        else
            @svg.node().style.height = height + 'px'
            @svg
                .transition()
                .attr('viewBox', viewBoxValue)
                .duration(1000)
                #.each('end', () =>
                #    @svg.node().style.height = height + 'px'
                #    return
                #)

        return

    resize: () =>

        if __DEV__
            debug = @debug or 0
            if debug or 0
                console.log('resize()')

        if not @svgContainer
            return
        device_width = window.innerWidth or screen.width
        if @deviceWidth is device_width
            return
        @svg.classed('invisible', true)
        @deviceWidth = device_width
        # see https://responsivedesign.is/develop/browser-feature-support/media-queries-for-common-device-breakpoints
        if device_width <= 1024
            #if device_width < 768
            # all ipads min 768, max 1024
            # max: iphone 6+ 736px, iphone6 667px, iphone5 568px, iphone4 480px, smartphones 480px
            #if device_width < 768
            #if device_width < 360
            if device_width <= 480
                view = 'mobile'
            else
                view = 'tablet'
        else
            view = 'desktop'
        @setResponsiveView(view, () =>
            @renderNode(@currentRef)
            events.emit('svg:resize')
            return
        )

        return

    setPageTitle: (ref) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('setPageTitle()')
                console.log('  @currentRef=', @currentRef)

        if not @titleContainer
            return
        title = 'Methods Map: ' + @nodeMap[@currentRef].name + ': SAGE Research Methods'
        @titleContainer.innerHTML = title

        return

    setScrollPosition: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('setScrollPosition()')

        if @currentView isnt 'mobile'
            return

        if not @svgContainer
            return

        scrollTop = @svgContainer.offsetTop
        #scrollTop = @svg.offsetTop
        targetNode = document.body
        if 0
            targetNode.scrollTop = scrollTop
        else
            #
            # smooth scroll
            #
            if targetNode.scrollTop is scrollTop
                #console.log('already there')
                return
            start = {top: targetNode.scrollTop}
            tween = Tween(start)
                .ease('out-circ')
                .to({top: scrollTop})
                .duration(1000)
            tween.update( (o) =>
                #console.log('  o.top=', o.top)
                #console.log('  scrollTop=', scrollTop)
                targetNode.scrollTop = o.top or 0
                return
            )
            animate = () ->
                raf(animate)
                tween.update()
                return
            tween.on('end', () =>
                animate = () ->
                    return
            )
            animate()

        return

    setResponsiveView: (view, callback) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('setResponsiveView("%s")', view)

        #if view is @currentView
        if @svg.classed(view)
            if __DEV__
                if debug
                    console.log('  already on view ' + view)
            if callback
                callback()
            return

        if __DEV__
            if debug
                console.log('  switching view to ' + view)

        @svg.classed(@currentView, false)
        @svg.classed(view, true)
        d3.selectAll('[data-mobile-list]')
            .attr('null', () ->
                for name in this.getAttribute('data-mobile-list').split(';')
                    if not name
                        continue
                    #console.log(name)
                    if view is 'mobile'
                        if this.hasAttribute('data-mobile-' + name + '-template')
                            value = this.getAttribute('data-mobile-' + name + '-template')
                            if this.hasAttribute('data-mobile-' + name + '-template-height')
                                height = this.getAttribute('data-mobile-' + name + '-template-height')
                                value = value.replace('{height}', height)
                        else
                            value = this.getAttribute('data-mobile-' + name)
                    else
                        value = this.getAttribute('data-backup-' + name)
                    #console.log('name=', name, 'value=', value, typeof(value))
                    this.setAttribute(name, value)
                return null
            )
        @currentView = view
        @resetMobileCarouselEffect(callback)

        return

    getData: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('getData()')
                console.log('  @JSONURL=', @JSONURL)

        d3.json(@JSONURL).get((error, root) =>
            if __DEV__
                if debug
                    console.log('  root=', root)
            @nodeMap = root.descriptions
            @nodeMap[@rootKey] = {
                'name': global["defaultName"]
                'definition': global["defaultDefinition"]
                'children': root.collection
                'parents': null
            }
            # assign 'root' as parent to first level
            for ref in root.collection
                #console.log(ref)
                if @rootKey not in @nodeMap[ref].parents
                    # NOTE: 8/2/19 now seeing these already pupulated with empty string (rootKey)
                    @nodeMap[ref].parents.push(@rootKey)
                #console.log('@nodeMap=', @nodeMap)
            @sortData()
            @mapSlugs()
            @focusNode(@nodeName, {history: false})
            events.emit('map:ready')
        )

        return

    sortData: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('sortData()')
                #console.log(@nodeMap)
                console.log(JSON.stringify(@nodeMap, null, 2))

        for k, v of @nodeMap
            #console.log(k)
            if k is @rootKey
                # NOTE: don't sort top node
                continue
            if v.children and v.children.length > 1
                # NOTE: sort children
                #console.log(v.children)
                names = []
                for ref in v.children
                    if ref
                        names.push({'name': @nodeMap[ref].name, 'ref': ref})
                #console.log('before:', JSON.stringify(names, null, 2))
                names.sort (a, b) ->
                    if a.name > b.name
                        return 1
                    if a.name < b.name
                        return -1
                    # a must be equal to b
                    return 0
                #console.log('after:', JSON.stringify(names, null, 2))
                #console.log('before:', JSON.stringify(v.children, null, 2))
                v.children = []
                for name in names
                    v.children.push(name['ref'])
                #console.log('after:', JSON.stringify(v.children, null, 2))
                #break
            if v.parents and v.parents.length > 1
                # NOTE: sort parents
                names = []
                for ref in v.parents
                    if ref
                        names.push({'name': @nodeMap[ref].name, 'ref': ref})
                #console.log('before (names):', JSON.stringify(names, null, 2))
                names.sort (a, b) ->
                    if a.name > b.name
                        return 1
                    if a.name < b.name
                        return -1
                    # a must be equal to b
                    return 0
                #console.log('after (names):', JSON.stringify(names, null, 2))
                #console.log('before (parents):', JSON.stringify(v.parents, null, 2))
                v.parents = []
                for name in names
                    if name is ""
                        continue
                    v.parents.push(name['ref'])
                #console.log('after (parents):', JSON.stringify(v.parents, null, 2))

        return

    mapSlugs: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('mapSlugs()')
                longest = ''

        slug_name = slug(global["defaultName"])
        @slugMap[slug_name] = @rootKey
        #console.log(@nodeMap)
        for k, v of @nodeMap
            #console.log(k)
            if __DEV__
                if debug
                    if v.name.length > longest.length
                        longest = v.name
            slug_name = slug(v.name)
            @slugMap[slug_name] = k
        if __DEV__
            if debug
                console.log('  longest:', longest)

        return

    drawTemplate: (callback) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('drawTemplate()')

        svgfile = require('./methods-map.svg')
        if __DEV__
            console.log('svgfile=', svgfile)
        d3.xml(svgfile).mimeType('image/svg+xml').get((error, xml) =>
            if error
                throw error
            try
                svgNode = document.importNode(xml.documentElement, true)
            catch err
                ## NOTE: ie9
                svgNode = document.importNodeIE9(xml.documentElement, document)
            if __DEV__
                if debug
                    console.log('  svgNode=', svgNode)
            callback(svgNode)
            return
        )

        return

    backupDefaultViews: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('backupDefaultViews()')

        d3.selectAll('[data-mobile-list]')
            .attr('null', () ->
                for name in this.getAttribute('data-mobile-list').split(';')
                    if not name
                        continue
                    #console.log(name)
                    value = this.getAttribute(name)
                    if value is null
                        value = ''
                    #console.log('  ', 'name=', name, 'value=', value, typeof(value))
                    this.setAttribute('data-backup-' + name, value)
                return null
            )

        return

    getTextAnchor: (x) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('getTextAnchor("%s")', x)

        if 10 > x > -10
            # center
            return 'middle'
        else if x > 10
            # on right
            return 'start'
        else if x < -10
            # on left
            return 'end'

        return

    getTextAnchorFromNode: (node) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('getTextAnchorFromNode("%s")', node)

        cx = node.circle.attr('cx')
        return @getTextAnchor(cx)

    clearAdjustTranslates: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('clearAdjustTranslates()')
                console.log('  @activeAdjustTranslateList=', @activeAdjustTranslateList)

        for transformNode in @activeAdjustTranslateList
            transformNode.removeAttribute('transform')
        @activeAdjustTranslateList = []

        return

    resizeBox: (node, adjustTranslateXpath=true, transitionDuration=0) =>

        if @currentView isnt 'mobile'
            return

        if __DEV__
            debug = @debug or 0
            if debug or 0
                console.log('resizeBox()')
                console.log('  node=', node)
                console.log('  adjustTranslateXpath=', adjustTranslateXpath)
                console.log('  transitionDuration=', transitionDuration)

        that = this
        d3node = d3.select(node)
        #if __DEV__
        #    window.d3node = d3node
        #    window.node = node
        #    do (node) ->
        #        setTimeout(() ->
        #            console.log('wow', node)
        #            console.log('wow', node.getBBox().height)
        #            return
        #        , 1000)
        nodeHeight = node.getBBox().height
        if nodeHeight is 0
            console.error('unable to determine node height from getBBox().height')
            #console.log(node)
            #console.log(node.getBBox())
        # apply scale
        if 1
            d3transform = d3GetTransforrm(d3node.attr('transform'))
            nodeHeight *= d3transform.scale[0]
        if __DEV__
            if debug
                console.log('  nodeHeight=', nodeHeight)
        d3.select(d3node.attr('data-mobile-adjust-height-xpath'))
            .attr('null', () ->
                textBox = d3.select(this)
                if __DEV__
                    if debug
                        console.log('  textBox=', textBox)
                # apply inverse scale
                if 1
                    #nodeHeight /= .335
                    d3transform = d3GetTransforrm(textBox.node().parentNode.getAttribute('transform'))
                    scale = d3transform.scale[0]
                    if __DEV__
                        if debug
                            console.log('  scale=', scale)
                    nodeHeight /= scale
                    if __DEV__
                        if debug
                            console.log('  nodeHeight(after inverse scale)=', nodeHeight)
                defaultHeight = parseInt(textBox.attr('data-mobile-d-template-height'), 10)
                if __DEV__
                    if debug
                        console.log('  defaultHeight=', defaultHeight)
                if textBox.node().hasAttribute('data-mobile-d-template-height-padding')
                    padding = parseInt(textBox.attr('data-mobile-d-template-height-padding'), 10)
                    if __DEV__
                        if debug
                            console.log('  padding=', padding)
                    nodeHeight += padding
                if __DEV__
                    if debug
                        console.log('  nodeHeight=', nodeHeight)
                value = textBox.attr('data-mobile-d-template')
                if __DEV__
                    if debug
                        console.log('  value=', value)
                value = value.replace('{height}', nodeHeight)
                if __DEV__
                    if debug
                        console.log('  value=', value)
                textBox
                    #.transition()
                    .attr('d', value)
                    #.duration(transitionDuration)
                textBox.attr('data-mobile-node-height', nodeHeight)  # NOTE: used for resizeAfterBox()
                if adjustTranslateXpath and textBox.node().hasAttribute('data-mobile-adjust-translate-xpath')
                    that.resizeAfterBox(textBox, transitionDuration)
                else
                    events.emit('svg:resize')
                return null
            )

        return

    resizeAfterBox: (textBox, transitionDuration=0) =>

        if @currentView isnt 'mobile'
            return

        if __DEV__
            debug = @debug or 0
            if debug or 0
                console.log('resizeAfterBox()')
                console.log('  textBox=', textBox.node())
                console.log('  transitionDuration=', transitionDuration)

        that = this
        defaultHeight = parseInt(textBox.attr('data-mobile-d-template-height'), 10)
        nodeHeight = parseInt(textBox.attr('data-mobile-node-height'), 10)
        if __DEV__
            if debug
                console.log('  defaultHeight=', defaultHeight)
                console.log('  nodeHeight=', nodeHeight)
        deltaHeight = nodeHeight - defaultHeight
        if __DEV__
            if debug
                console.log('  deltaHeight=', deltaHeight)
        transform = 'translate(0,' + deltaHeight + ')'
        if __DEV__
            if debug
                console.log('  transform=', transform)
        d3.selectAll(textBox.attr('data-mobile-adjust-translate-xpath'))
            .transition()
            .attr('transform', () ->
                transformNode = this
                if __DEV__
                    if debug
                        console.log('  transformNode=', transformNode)
                that.activeAdjustTranslateList.push(transformNode)
                return transform
            )
            .duration(transitionDuration)
            .on('end', () ->
                events.emit('svg:resize')
                return
            )

        return

    transitionBox: (node, transitionDuration=@transitionDuration) =>

        if @currentView isnt 'mobile'
            return

        if __DEV__
            debug = @debug or 0
            if debug or 0
                console.log('transitionBox()')
                console.log('  node=', node)
                console.log('  transitionDuration=', transitionDuration)

        d3node = d3.select(node)

        d3.select(d3node.attr('data-mobile-adjust-height-xpath'))
            .attr('null', () ->
                textBox = d3.select(this)
                old_value = textBox.attr('d')
                if __DEV__
                    if debug
                        console.log('  old_value=', old_value)
                textBox.attr('data-restore-d', old_value)
                if __DEV__
                    if debug
                        console.log('  textBox=', textBox.node())
                if 0
                    d = textBox.attr('data-mobile-d-template').replace('{height}', textBox.attr('data-mobile-d-template-height'))
                    if __DEV__
                        if debug
                            console.log('  d=', d)
                    textBox.attr('d', d)
                d3.selectAll(textBox.attr('data-mobile-adjust-translate-xpath'))
                    .attr('null', () ->
                        transformNode = d3.select(this)
                        old_value = transformNode.attr('transform')
                        if __DEV__
                            if debug
                                console.log('    old_value=', old_value)
                        transformNode.attr('data-restore-transform', old_value)
                        if __DEV__
                            if debug
                                console.log('    transformNode=', transformNode.node())
                        #transformNode.setAttribute('transform', transform)
                        #that.activeAdjustTranslateList.push(transformNode)
                        #events.emit('svg:resize')
                        return null
                    )
                return null
            )

        nodes = d3node.selectAll('g.node')
        if __DEV__
            if debug
                console.log('  nodes=', nodes)

        if 1
            # NOTE: collapse
            y0 = null
            y = null
            nodes
                .attr('transform', (d, i) ->
                    d3this = d3.select(this)
                    text = d3this.select('text')
                    y = text.attr('y')
                    if y0 is null
                        y0 = y
                    #console.log(d3this)
                    return 'translate(0,-' + (y - y0) + ')'
                )
                #.attr('null', (d, i) ->
                #    d3this = d3.select(this)
                #    text = d3this.select('text')
                #    y = text.attr('y')
                #    if y0 is null
                #        y0 = y
                #    #console.log(d3this)
                #    d3this.attr('transform', 'translate(0,-' + (y - y0) + ')')
                #    return
                #)

        if 0
            @resizeBox(d3node.node(), true, 0)

        if 1
            that = this
            node_count = nodes.size()
            if __DEV__
                if debug
                    console.log('  node_count=', node_count)
            node_i = 0
            nodes
                .attr('opacity', '0')
                .transition()
                #.delay(() ->
                #    node_i += 1
                #    delay = 300 * node_i
                #    #console.log('node_i=', node_i, 'delay=', delay)
                #    return delay
                #)
                .duration(transitionDuration)
                .attr('transform', 'translate(0,0)')
                .attr('opacity', '1')
                #.on('start', () ->
                #    return
                #)
                .on('end', () ->
                    node_count -= 1
                    #console.log('node_count=', node_count)
                    #if 1 or node_count is 0
                    #    that.resizeBox(d3node.node(), true, 0)
                    return
                )

        return

    getRefCounts: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('getRefCounts()')
                console.log('  @refCountTries=', @refCountTries)
                console.log('  @refCountTimeout=', @refCountTimeout)
                console.log('  @showRefCounts=', @showRefCounts)

        ref = @currentRef

        if not @showRefCounts
            @pushDataLayers(ref)
            return

        @refCountTries += 1
        if @refCountTries > @maxRefCountTries
            console.error('unable to get ref counts, maximum retries reached (' + @maxRefCountTries + ')')
            return
        url = reactive('<div url="' + global['urls']['refCount'] + '" />', {ref: ref}).el.getAttribute('url')
        if debug or 0
            console.log('  url=', url)
        if @refRequest
            if debug
                console.log('  already @refRequest, aborting')
            @refRequest.abort()
        @refRequest = request
            .get(url)
            .set('Accept', 'application/json')
            .end((err, res) =>
                @refRequest = null
                clearTimeout(reqTimeout)
                if err
                    console.error(err)
                    #return
                else
                    #console.log('res', res.text)
                    for o in JSON.parse(res.text)
                        #console.log(o)
                        #console.log(o.Ref)
                        #console.log(@nodeMap[o.Ref])
                        if not @nodeMap[o.Ref]
                            continue
                        if not @nodeMap[o.Ref].count
                            @nodeMap[o.Ref].count = o.NumberOfTitles
                #console.log(@nodeMap)
                @pushRefCounts(ref)
                @pushDataLayers(ref)
                @refCountTries = 0
                return
            )
            .on('abort', () =>
                @refRequest = null
                clearTimeout(reqTimeout)
                #console.error('aborting xhr')
                #@refCountTries = 0
                return
            )
        reqTimeout = setTimeout((() =>
            #console.error('unable to retreive node counts')
            @refRequest.abort()
            @getRefCounts(ref)
            return
        ) , @refCountTimeout)

        return

    pushRefCounts: (ref) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('pushRefCounts(%s)', ref)

        if not @showRefCounts
            return

        ref = @currentRef
        that = this
        count = @nodeMap[ref].count or 0
        count = that.commasFormatter(count)
        window.definitionLink = @definitionLink
        definitionLink = @definitionLink.selectAll('tspan')
        if definitionLink.size() > 0
            # NOTE: no nodes when top node is selected from second level node
            definitionLink
                .last()
                .text((d, i) ->
                    text = this.textContent
                    #if count and not d3.select(this).classed('counted')
                    if not d3.select(this).classed('counted')
                        text += ' ' + '(' + count + ')'
                    return text
                )
                .classed('counted', true)
        for group in [@narrowerGroupLayer1, @broaderGroupLayer1, @relatedGroupLayer1]
            group.selectAll('g.node')
                .attr('null', (d, i) ->
                    ref2 = this.getAttribute('id')
                    if not ref2
                        return
                    count = that.nodeMap[ref2].count or 0
                    count = that.commasFormatter(count)
                    #console.log('ref2=', ref2)
                    #console.log('count=', count)
                    #d3.select(this).selectAll('text')
                    text = d3.select(this).selectAll('text')
                    text.attr('data-item-name', text.attr('data-item-name') + ' ' + '(' + count + ')')  # NOTE: dataLayer
                    text.append('tspan')
                        .attr('class', 'count')
                        .attr('dx', '5')
                        .text('(' + count + ')')
                    return null
                )

        return

    pushDataLayers: (ref) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('pushDataLayers()')
                console.log('  ref=', ref)
                console.log('  @currentRef=', @currentRef)
                console.log('  @nodeMap[%s]=', ref, @nodeMap[ref])

        #ref = @currentRef
        nodeRef = @nodeMap[ref]
        if __DEV__
            if debug
                console.log('  nodeRef=', nodeRef)
        parents = nodeRef.parents
        children = nodeRef.children
        related = nodeRef.related
        if __DEV__
            if debug
                console.log('  parents=', parents)
                console.log('  children=', children)
                console.log('  related=', related)
        dataLayer = window['srm']["methodsMap"]["dataLayer"]
        if not ref
            dataLayerTemplate = JSON.parse(JSON.stringify(window['srm']["methodsMap"]["dataLayerTemplate0"]))
        else
            dataLayerTemplate = JSON.parse(JSON.stringify(window['srm']["methodsMap"]["dataLayerTemplate"]))
        if __DEV__
            if debug
                console.log('  dataLayerTemplate=', dataLayerTemplate)
        # NOTE: left-to-right, top-to-bottom
        for bubble, i in [
            ['broad', parents],
            ['narrower', children],
            ['related', related],
        ]
            #console.log('bubble=', bubble)
            if not bubble[1]
                continue
            for childRef, i2 in bubble[1]
                if 0
                    position = (i + 1).toString()
                else
                    position = (i2 + 1).toString()
                childNode = @nodeMap[childRef]
                if __DEV__
                    if debug
                        console.log('    i=', i, ', childRef=', childRef, ', childNode=', childNode)
                dataLayerItem = JSON.parse(JSON.stringify(window['srm']["methodsMap"]["dataLayerItemTemplate"]))
                dataLayerItem.name = childNode.name
                if @showRefCounts
                    childCount = childNode.count or 0
                    childCount = @commasFormatter(childCount)
                    dataLayerItem.name += ' ' + '(' + childCount + ')'
                dataLayerItem.action += '-' + bubble[0]
                dataLayerItem.position = position
                dataLayerTemplate["module"][0]["items"].push(dataLayerItem)
        dataLayer.push(dataLayerTemplate)
        if __DEV__
            if debug
                console.log('  dataLayer=', dataLayer)
                console.log('  dataLayer[0].module[0].items=', dataLayer[0].module[0].items)

        return

    focusNode: (ref, options={history: true}) =>

        if __DEV__
            debug = @debug or 0
            if debug or 0
                console.log('focusNode()')
                console.log('  ref=', ref)
                console.log('  options=', options)
                #console.log('  @nodeMap[%s]=', ref, @nodeMap[ref])
                console.log('  @nodeMap[%s]=', ref, @nodeMap[ref])

        if ref is 'index.min.html' or ref is 'index.html'
            ref = ''
        if ref not of @nodeMap
            if ref of @slugMap
                ref = @slugMap[ref]
        #if ref is @currentRef
        #    console.log('already rendered')
        #    return
        @currentRef = ref
        if @currentRef and @currentRef not of @nodeMap
            console.error('ref ' + @currentRef + ' provided but not found in json at ' + @JSONURL)
            return
        @setPageTitle()
        @setScrollPosition()
        @pushHistory(options)
        @renderNode()
        @updateVirtualBuffer()

        return

    decrementBubbleCount: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('decrementBubbleCount()')

        @bubbleCount -= 1
        if @bubbleCount is 0
            events.emit('node:rendered')

        return

    renderNode: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('renderNode()')
                console.log('  @currentRef=', @currentRef)

        if @expandedView
            @toggleExpandedView()
        if @currentView isnt 'mobile'
            @clearAdjustTranslates()
        @bubbleCount = 5
        @clearMain(() =>
            @pushMain(() =>
                @decrementBubbleCount()
                return
            )
        )
        @clearDefinition(() =>
            @pushDefinition(() =>
                @decrementBubbleCount()
                return
            )
        )
        @clearBroaderChildren(() =>
            @pushBroaderChildren(() =>
                @repositionBroaderChildren()
                @decrementBubbleCount()
                events.emit('bubble:populated', 'broader')
                return
            )
        )
        @clearRelatedChildren(() =>
            @pushRelatedChildren(() =>
                @repositionRelatedChildren()
                @decrementBubbleCount()
                events.emit('bubble:populated', 'related')
                return
            )
        )
        @clearNarrowerChildren(() =>
            @pushNarrowerChildren(() =>
                @repositionNarrowerChildren()
                @decrementBubbleCount()
                events.emit('bubble:populated', 'narrower')
                return
            )
        )

        return

    toggleHover: () ->

        if __DEV__
            debug = @debug or 0
            if debug or 0
                console.log('toggleHover()')

        #if that.currentView is 'mobile'
        #    return
        #console.log('toggleHover()')
        #console.log('  @currentView=', that.currentView)
        radii = radius = null
        if this.circle
            radii = this.circle.node().radii
        #console.log('radii=', radii)
        parent = d3.select(this.parentNode)
        if parent.classed('hover')
            parent.classed('hover', false)
            if radii
                radius = radii[0]
        else
            if radii
                radius = radii[1]
            parent.classed('hover', true)
        #d3.select(this).attr('r', radius)
        if radius
            this.circle.attr('r', radius)

        return

    centerNarrowerBubble: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('centerNarrowerBubble()')

        if @currentView isnt 'mobile'
            return
        ref = @currentRef
        node = @nodeMap[ref]
        if __DEV__
            if debug
                console.log('  node=', node)
        if not node or not node.children or node.children.length is 0
            @focusBubble('broader', null)
        else
            @focusBubble('narrower', null)

        return

    focusBubble: (name, event, callback) =>

        if __DEV__
            debug = @debug or 0
            if debug or 0
                console.log('focusBubble("' + name + '")')
                console.log('  event=', event)
                console.log('  @transitionInProgress=', JSON.stringify(@transitionInProgress))
                console.log('  @currentView=', @currentView)

        if @transitionInProgress
            return

        @transitionInProgress = true
        #if @debugTransitions
        #    console.log('  setting @transitionInProgress to', JSON.stringify(@transitionInProgress))
        node = box = null
        if name is 'narrower'
            group = @narrowerGroup
            node = @narrowerGroup.node()
            box = @narrowerGroupLayer1.node()
        else if name is 'broader'
            group = @broaderGroup
            node = @broaderGroup.node()
            box = @broaderGroupLayer1.node()
        else if name is 'related'
            group = @relatedGroup
            node = @relatedGroup.node()
            box = @relatedGroupLayer1.node()
        else if name is 'main'
            group = @mainGroup
            node = @mainGroup.node()
        # if not node
        #     console.log('unable to identify bubble name:', name)
        #     return

        # NOTE: move selected node to top layer
        if group
            group.moveToFront()

        if @currentView is 'mobile'
            #console.log('  node=', node)
            #console.log('  box=', box)
            @mobileCarouselEffect(node, box, () =>
                @transitionInProgress = false
                #if @debugTransitions
                #    console.log('  setting @transitionInProgress to', JSON.stringify(@transitionInProgress))
                #@resizeBox(box, true, 0)
                return
            )
            return

        @toggleExpandedView(node, event, () =>
            @transitionInProgress = false
            #if @debugTransitions
            #    console.log('  setting @transitionInProgress to', JSON.stringify(@transitionInProgress))
            if callback
                callback()
            return
        )

        return

    sortCompare:  (a, b) ->
        return a[0] - b[0]

    resetMobileCarouselEffect: (callback) =>

        debug = @debug or 0

        if __DEV__
            if debug
                console.log('resetMobileCarouselEffect()')

        transitionDuration = @transitionDuration
        groups = [@narrowerGroup, @broaderGroup, @relatedGroup]
        count = groups.length
        #console.log('  count=', count)
        for group in groups
            #console.log('  group', group.node())
            group.classed('selected', false)
            circle_group = group.select('.circle-group')
            #console.log('  circle_group', circle_group.node())
            circle_group
                .transition()
                .attr('transform', () ->
                    selected_transform_index = parseInt(this.getAttribute('data-mobile-carousel-transform-index'), 10)
                    #console.log('selected_transform_index=', selected_transform_index)
                    transform_list = this.getAttribute('data-mobile-carousel-transform-list').split(';')
                    #console.log('transform_list=', transform_list)
                    transform = transform_list[selected_transform_index]
                    #console.log('transform=', transform)
                    return transform
                )
                .attr('null', () ->
                    count -= 1
                    if callback and count is 0
                        callback()
                    return null
                )
                .duration(transitionDuration)
                .on('end', () ->
                    count -= 1
                    if callback and count is 0
                        callback()
                    return
                )

        return

    mobileCarouselEffect: (node, box, callback) =>

        if __DEV__
            debug = @debug or 0
            if debug or 0
                console.log('mobileCarouselEffect()')
                console.log('  node=', node)
                console.log('  box=', box)

        box_group = d3.select(box)
        box_node_count = box_group.selectAll('.node').size()
        if box_node_count is 0
            if __DEV__
                if debug
                    console.log('  box_node_count=', box_node_count, 'returning')
            @transitionInProgress = false
            return
        group = d3.select(node)
        transitionDuration = @transitionDuration
        middle_index = 1
        selected_circle_group = group.select('.circle-group')
        if __DEV__
            if debug
                console.log('  selected_circle_group=', selected_circle_group.node())
        selected_transform_index = parseInt(selected_circle_group.attr('data-mobile-carousel-transform-index'), 10)
        if selected_transform_index is middle_index
            group.classed('selected', true)  # NOTE: not set on initial page load
            #console.log('its already active and selected')
            @resizeBox(box, true, 0)
            if callback
                callback()
            return
        # NOTE: move selected node to top layer
        # group.moveToFront()
        # NOTE: apply transforms
        positions = []
        count = 0
        if __DEV__
            if debug
                console.log('  iteerate groups...')
        for group, i in [@narrowerGroup, @broaderGroup, @relatedGroup]
            if __DEV__
                if debug
                    console.log('    group=', group.node())
            selected = node is group.node()
            group.classed('selected', selected)
            circle_group = group.select('.circle-group')
            if __DEV__
                if debug
                    console.log('    circle_group=', circle_group.node())
            if selected
                mobile_node_box_group = group.select('.mobile-node-box')
                #if debug or 1
                #    console.log('    mobile_node_box_group=', mobile_node_box_group.node())
                node_group = group.select('.node-child')
                #if debug or 1
                #    console.log('    node_group=', node_group.node())
                nodes = node_group.selectAll('g.node')
                #console.log('text=', text)
                node_count = nodes.size()
                if 1
                    #@resizeBox(node_group.node(), false, 0)
                    @resizeBox(node_group.node(), true, 0)
                if 1
                    @transitionBox(node_group.node(), transitionDuration)
            transform_list = circle_group.attr('data-mobile-carousel-transform-list')
            if __DEV__
                if debug
                    console.log('    transform_list=', transform_list)
            if not transform_list
                continue
            transform_list = transform_list.split(';')
            if circle_group is selected_circle_group
                transform_index = middle_index
            else
                transform_index = parseInt(circle_group.attr('data-mobile-carousel-transform-index'), 10)
                if __DEV__
                    if debug
                        console.log('    transform_index (before)=', transform_index)
                if selected_transform_index < middle_index
                    # NOTE: swipe right / click left
                    transform_index += 1
                else
                    # NOTE: swipe left / click right
                    transform_index -= 1
                max_index = transform_list.length - 1
                if transform_index < 0
                    transform_index = max_index
                else if transform_index > max_index
                    transform_index = 0
            if __DEV__
                if debug
                    console.log('    transform_index=', transform_index)
            transform = d3GetTransforrm(transform_list[transform_index])
            if __DEV__
                if debug
                    console.log('    transform=', transform.toString())
            circle_group
                .attr('data-mobile-carousel-transform-index', transform_index)
                .transition()
                .attr('transform', transform.toString())
                #.attr('opacity', '1')
                .duration(transitionDuration)
                .on('start', () =>
                    #console.log('start')
                    count += 1
                    return
                )
                .on('end', () =>
                    #console.log('end')
                    count -= 1
                    #if count is 0 and callback
                    #    callback()
                    return
                )
        if callback
            callback()

        return

    toggleExpandedView: (node, event, callback) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('toggleExpandedView()')
                console.log('  node=', node)
                console.log('  event=', event)
                console.log('  @expandedView=', @expandedView)
                console.log('  @currentView=', @currentView)

        if node and node.id is 'main'
            node = null
        if node
            d3node = d3.select(node)
            if d3node.selectAll('.node').size() is 0
                if callback
                    callback()
                return

        # reset in case of orientation change for when @currentView tablet -> mobile (i.e. landscape -> portrait on mobile)
        @svg.classed('expanded', false)
        for group in [@mainGroup, @narrowerGroup, @broaderGroup, @relatedGroup]
            group.classed('expanded', false)
            group.classed('hidden-bubble', false)

        # NOTE: per SRMPD-2060, hide back button on keyboard navigation
        if event and event.type is 'keyup'
            @narrowerBackNode.classed('hidden', true)
        else
            @narrowerBackNode.classed('hidden', false)
        if __DEV__
            if debug
                console.log('%s back button', if @narrowerBackNode.classed('hidden') then 'hiding' else 'showing')

        if @currentView is 'mobile'
            if callback
                callback()
            return

        expandedView = @expandedView
        @expandedView = not @expandedView
        transitionCount = 0

        if @expandedView
            @narrowerViewMore
                .classed('active', false)

        if not node
            @svg.classed('expanded', false)
            for group in [@mainGroup, @narrowerGroup, @broaderGroup, @relatedGroup]
                transform0_attr = group.attr('transform0')
                if transform0_attr
                    # console.log('transform0_attr=', transform0_attr)
                    # group.node().removeAttribute('transform0')
                    group.attr('transform0', null)
                    transform = d3GetTransforrm(transform0_attr)
                    group
                        .transition()
                        .attr('transform', transform.toString())
                        #.attr('opacity', '1')
                        .duration(1000)
                        .on('start', () =>
                            #console.log('start')
                            transitionCount += 1
                            return
                        )
                        .on('end', () =>
                            #console.log('end')
                            transitionCount -= 1
                            if transitionCount is 0 and callback
                                callback()
                            return
                        )
                if group is @narrowerGroup
                    @repositionNarrowerChildren()
                else if group is @broaderGroup
                    @repositionBroaderChildren()
                else if group is @relatedGroup
                    @repositionRelatedChildren()
                if group.classed('expanded')
                    cx = @expandedGuideMiddleCircle.attr('cx')
                    cy = @expandedGuideMiddleCircle.attr('cy')
                    @mainLine
                        .transition()
                        .attr('x1', cx)
                        .attr('y1', cy)
                        .attr('x2', cx)
                        .attr('y2', cy)
                        .duration(1000)
                    group.classed('expanded', false)
                group.classed('hidden-bubble', false)
        else
            @svg.classed('expanded', true)
            id = d3node.attr('id')
            #console.log('d3node', d3node)
            x1 = @expandedGuideLeftCircle.attr('cx')
            y1 = @expandedGuideLeftCircle.attr('cy')
            x2 = @expandedGuideMiddleCircle.attr('cx')
            y2 = @expandedGuideMiddleCircle.attr('cy')
            scaleX = 0.58678502
            deltaX = -158.3118  # position on #expanded_guide_left
            deltaY = 166.14805
            for group in [@mainGroup, @narrowerGroup, @broaderGroup, @relatedGroup]
                #console.log('  group', group.node(), d3node.node() is group.node())
                transform_attr = group.attr('transform0')
                if transform_attr
                    # console.log('SKIPPING BECAUSE transform0_attr=', transform0_attr)
                else
                    transform_attr = group.attr('transform')
                transform = d3GetTransforrm(transform_attr)
                #console.log('  transform', transform.toString())
                group
                    .attr('transform0', transform.toString())
                if d3node.node() is group.node()
                    group.classed('expanded', true)
                    if group is @narrowerGroup
                        transform.translate[0] += -180
                        @repositionNarrowerChildren()
                    else if group is @broaderGroup
                        if 0
                            transform.translate[0] += 180
                        else
                            transform.translate[0] += 180
                            x1 = @expandedGuideRightCircle.attr('cx')
                            deltaX = 576  # position on #expanded_guide_right
                        @repositionBroaderChildren()
                    else if group is @relatedGroup
                        transform.scale = 1
                        transform.translate[1] += -160
                        @repositionRelatedChildren()
                    #console.log(group.node())
                    circle = group.select('g.circle-group circle.circle')
                    #console.log(circle.node())
                    @mainLine
                        .attr('x2', circle.attr('cx'))
                        .attr('y2', circle.attr('cy'))
                    #console.log(@mainLine.node())
                    #console.log('  transform', transform.toString())
                    d3node
                        .transition()
                        .attr('transform', transform.toString())
                        .duration(1000)
                        .on('start', () =>
                            transitionCount += 1
                            return
                        )
                        .on('end', () =>
                            transitionCount -= 1
                            if transitionCount is 0 and callback
                                callback()
                            return
                        )
                else if group isnt @mainGroup
                    #group
                    #    .attr('opacity', '1')
                    #    .transition()
                    #    .attr('opacity', '0')
                    #    .duration(1000)
                    group.classed('hidden-bubble', true)
            @mainGroup
                .transition()
                .attr('transform', 'matrix(' + scaleX + ',0,0,' + scaleX + ',' + deltaX + ',' + deltaY + ')')
                .duration(1000)
            @mainLine
                .transition()
                .attr('x1', x1)
                .attr('y1', y1)
                .attr('x2', x2)
                .attr('y2', y2)
                .duration(1000)

        return

    pushHistory: (options={history: true}) =>

        if __DEV__
            debug = @debug or 0
            if debug or 0
                console.log('pushHistory()')
                console.log('  @history=', @history)

        that = this
        ref = @currentRef
        if not options.history
            return
        if @browserHistory
            #
            # window.history
            #
            name = @nodeMap[ref].name
            slug_name = slug(name)
            #url = location.href.replace(/\/$/, "") + '/' + slug_name
            url = '/'
            if window['srm']['localhost']
                url += 'srm3.0/'
            url += 'methods-map/'
            url += slug_name
            if __DEV__
                if debug
                    console.log('  ref=' + ref)
                    console.log('  name=' + name)
                    console.log('  slug_name=' + slug_name)
                    console.log('  url=' + url)
                    console.log('  window.history.state(before)=' + JSON.stringify(window.history.state))
            try
                window.history.pushState({ref: ref}, name, url)
            catch err
                if __DEV__
                    console.warn('history not available')
                else
                    console.error(err)
            if __DEV__
                if debug
                    console.log('  window.history.state(after)=' + JSON.stringify(window.history.state))
        if @history[@history.length - 1] isnt ''
            @history.shift()
            @history.push('')
        if __DEV__
            if debug
                console.log('  @history=', @history)
        for historyRef, i in @history
            if @currentView is 'mobile' and i < 3
                continue
            if __DEV__
                if debug
                    console.log('   i=%s, historyRef=%s', i, historyRef)
            if historyRef is ''
                @history[i] = ref
                break
        if __DEV__
            if debug
                console.log('  @history=', @history)
                console.log('  saving history', @history)
        cookie('history', JSON.stringify(@history), {path: '/'})
        @showHistory()

        return

    showHistory: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('showHistory()')
                console.log('  @history=', @history)

        that = this
        @historyGroup = @svg.select('#history')
        if @currentView is 'mobile'
            adjusted_history = @history[3..]
        else
            adjusted_history = @history
        tabindex = parseInt(@historyGroup.attr('data-starting-tabindex'), 10)
        for ref, i in adjusted_history
            if __DEV__
                if debug
                    console.log('   i=%s, ref=%s', i, ref)
            node = @nodeMap[ref]
            if ref
                name = node.name
            else
                name = ''
            if __DEV__
                if debug
                    console.log('   name=%s', name)
            groupLayer = d3.select('#history' + (i + 1))
            if name isnt ''
                groupLayer.classed('hidden', false)
            else
                groupLayer.classed('hidden', true)

            #
            # circles
            #
            circle = groupLayer.select('circle')
            circle
                .attr('r', () ->
                    this.ref = ref
                    this.circle = circle
                    this.radii = [8, 10]
                    return this.radii[0]
                )
                .attr('alt', () ->
                    return name
                )
                .attr('aria-label', () ->
                    return name
                )
                .on('mouseover', @toggleHover)
                .on('mouseout', @toggleHover)
                .on('click', (event) ->
                    #console.log('event=', event)
                    that.focusNode(this.ref, {history: false})
                    return
                )
            #
            # xlink
            #
            xlink = groupLayer.select('a')
                .attr('xlink:href', () ->
                    slug_name = slug(node.name)
                    #url = location.href.replace(/\/$/, "") + '/' + slug_name
                    url = '/'
                    if window['srm']['localhost']
                        url += 'srm3.0/'
                    url += 'methods-map/'
                    url += slug_name
                    #console.log('url=', url)
                    return url
                )
                .attr('null', (d, i) ->
                    this.ref = ref
                    this.circle = circle
                    this.groupLayer = groupLayer
                    return null
                )
                .on('click', (event) ->
                    #console.log('event=', event)
                    that.focusNode(this.ref, {history: false})
                    return
                )
                .on('mouseover', @toggleHover)
                .on('mouseout', @toggleHover)

            if name isnt ''
                xlink.classed('hidden', false)
            else
                xlink.classed('hidden', true)

            if @forceTabIndex
                xlink.attr('tabindex', tabindex + i)
            xlink.node().addEventListener('click', (event) ->
                # NOTE: needed to grab event, isn't passed in .on() above
                event.preventDefault()
                event.stopPropagation()
                return false
            )
            #
            # text
            #
            textNode = xlink.select('text')
            #textNode = xlink.select('a text')
            textNode
                .attr('null', () ->
                    this.ref = ref
                    this.circle = circle
                    return null
                )
                #.on('click', () ->
                #    that.focusNode(this.ref, {history: false})
                #    return
                #)
                #.on('mouseover', @toggleHover)
                #.on('mouseout', @toggleHover)
            if 0
                textNode.select('tspan').text(name)
            else
                #
                # wrap
                #
                textNode.selectAll('tspan').remove()
                width = 180
                #console.log('textNode', textNode.node())
                x = textNode.attr('x')
                h = 18
                dy = textFlow(name, textNode.node(), width, x, h, false);
            if 0
                groupLayer.select('title').text(name)
            if __DEV__
                if debug
                    console.log('   i=%s, ref=%s', i, ref)

        return

    setupSVGNode: (svgNode) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('setupSVGNode()')

        @svg = d3.select(svgNode)
        if __DEV__
            window.svg = @svg
        @svg.classed(@defaultView, true)
        #@svg.attr('opacity', 0)
        @svg.node().style.opacity = 0
        @svgContainer.appendChild(svgNode)

        return

    toggleAccessibityMode: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('toggleAccessibityMode()')
                console.log('  @htmlContainer.classList=', @htmlContainer.classList)

        if @htmlContainer.classList.contains('hidden')
            @svg.classed('hidden', true)
            @htmlContainer.classList.remove('hidden')
            @accessibilityMode = true
        else
            @svg.classed('hidden', false)
            @htmlContainer.classList.add('hidden')
            @accessibilityMode = false

        if __DEV__
            if debug
                console.log('@svg.node()=', @svg.node())
                console.log('@htmlContainer=', @htmlContainer)
                console.log('  @htmlContainer.classList=', @htmlContainer.classList)

        if 0
            @focusDefinition()
            if __DEV__
                if debug
                    console.log('  document.activeElement=', document.activeElement)
        else
            events.on('bubble:populated', (name) =>
                if __DEV__
                    if debug
                        console.log('  bubble:populated', name)
                if name is 'narrower'
                    @focusDefinition()
                    if __DEV__
                        if debug
                            console.log('  document.activeElement=', document.activeElement)

                return
            )
        @renderNode()  # NOTE: recalculate all text widths (textFlow)
        events.emit('accessibility:toggled', @accessibilityMode)

        return

    setupHTMLNode: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('setupHTMLNode()')

        #@svg.node().style.display = 'none'

        @htmlDefinition = [{
            'name': 'Moderators',
            'text': 'Some text',
            'href': '/moderators'
        }]
        @htmlBubbles = [
            #{name: 'Broader Terms', 'terms': [{name: 'one', href: '/one'}, {name: 'two', href: '/two'}]},
            {name: 'broader', title: 'Broader Terms', 'terms': []},
            {name: 'narrower', title: 'Narrower Terms', 'terms': []},
            {name: 'related', title: 'Related Terms', 'terms': []},
        ]
        model = {definition: @htmlDefinition, bubbles: @htmlBubbles}
        handlers = {
            toggle_accessibility_mode: (() ->
                events.emit("accessibility:toggle")
                return
            ),
            focus_node: ((event) ->
                event.preventDefault()
                event.stopPropagation()
                events.emit("node:load", event.target.dataset.ref)
                return
            ),
            title_link: ((event) =>
                event.preventDefault()
                event.stopPropagation()
                title_link_href = '.accessible-bubble.narrower a.accessible-term-link'
                defintion_link_wrapper = @htmlContainer.querySelector('.accessible-definition-link')
                if defintion_link_wrapper.classList.contains('hidden')
                    target_node = @htmlContainer.querySelector('.accessible-bubble.narrower a.accessible-term-link')
                else
                    target_node = defintion_link_wrapper.querySelector('a')
                #console.log('target_node=', target_node)
                target_node.focus()
                return
            )
        }

        # NOTE: shortcuts
        @htmlBroaderBubbleTerms = @htmlBubbles[0].terms
        @htmlNarrowerBubbleTerms = @htmlBubbles[1].terms
        @htmlRelatedBubbleTerms = @htmlBubbles[2].terms
        #@htmlBroaderBubbleTermEmptyNode = @htmlContainer.querySelector('')

        @htmlContainer = reactive(require('./methods-map.html'), model, {delegate: handlers}).el
        @svgContainer.appendChild(@htmlContainer)

        return

    setupSwipe: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('setupSwipe()')

        @middleGroup = @svg.select('g#middle')
        hammer = new Hammer(@middleGroup.node())
        hammer.get('swipe').set({direction: Hammer.DIRECTION_ALL})
        hammer.on('swipe', (event) =>
            if __DEV__
                if debug
                    console.log('  event.direction=', event.direction)
                    if event.direction is Hammer.DIRECTION_LEFT
                        console.log('    left')
                    else if event.direction is Hammer.DIRECTION_RIGHT
                        console.log('    right')
                    else if event.direction is Hammer.DIRECTION_DOWN
                        console.log('    down')
                    else if event.direction is Hammer.DIRECTION_UP
                        console.log('    up')
            if @currentView is 'mobile'
                if event.direction is Hammer.DIRECTION_UP or event.direction is Hammer.DIRECTION_DOWN
                    return
                # determine which node to click
                positions = []
                for group in [@narrowerGroup, @broaderGroup, @relatedGroup]
                    #console.log('  group=', group.node())
                    circle_group = group.select('.circle-group')
                    #console.log('  circle_group=', circle_group.node())
                    transform_index = parseInt(circle_group.attr('data-mobile-carousel-transform-index'), 10)
                    if transform_index is 0 and event.direction is Hammer.DIRECTION_RIGHT
                        break
                    transform_list = circle_group.attr('data-mobile-carousel-transform-list').split(';')
                    max_index = transform_list.length - 1
                    if transform_index is max_index  and event.direction is Hammer.DIRECTION_LEFT
                        break
                if group
                    #console.log('group=', group.node())
                    @focusBubble(group.node().id, event)
                return
            if @expandedView
                if @narrowerGroup.classed('expanded') and event.direction is Hammer.DIRECTION_RIGHT
                    #events.emit('click', @mainGroup.node())
                    @focusBubble(@mainGroup.node().id, event)
                else if @broaderGroup.classed('expanded') and event.direction is Hammer.DIRECTION_LEFT
                    #events.emit('click', @mainGroup.node())
                    @focusBubble(@mainGroup.node().id, event)
                else if @relatedGroup.classed('expanded') and (event.direction is Hammer.DIRECTION_DOWN or  event.direction is Hammer.DIRECTION_RIGHT)
                    #events.emit('click', @mainGroup.node())
                    @focusBubble(@mainGroup.node().id, event)
            else
                if event.direction is Hammer.DIRECTION_LEFT
                    #events.emit('click', @narrowerCircle.node())
                    @focusBubble(@narrowerGroup.node().id, event)
                else if event.direction is Hammer.DIRECTION_RIGHT
                    #events.emit('click', @broaderCircle.node())
                    @focusBubble(@broaderGroup.node().id, event)
                else if event.direction is Hammer.DIRECTION_UP
                    #events.emit('click', @relatedCircle.node())
                    @focusBubble(@relatedGroup.node().id, event)
            return
        )

        return

    setupChildNodes: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('setupChildNodes()')

        @setupBroaderChildren()
        @setupNarrowerChildren()
        @setupBack()
        @setupViewMore()
        @setupRelatedChildren()
        @setupMain()
        @setupDefinition()

        return

    setupMain: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('setupMain()')

        @mainGroup = @svg.select('g#main')
        hammer = new Hammer(@mainGroup.node())
        hammer.on('tap', (event) =>
            if @currentView is 'mobile'
                return
            if @transitionInProgress
                return
            if @expandedView
                @transitionInProgress = true
                #if @debugTransitions
                #    console.log('  setting @transitionInProgress to', JSON.stringify(@transitionInProgress))
                @toggleExpandedView(null, event, () =>
                    @transitionInProgress = false
                    #if @debugTransitions
                    #    console.log('  setting @transitionInProgress to', JSON.stringify(@transitionInProgress))
                    return
                )
            return
        )
        @mainCircle = @mainGroup.select('circle')
        @mainLine = @svg.select('line#main_line')
        #@mainBubble = @mainGroup.select('circle')
        @mainText = @mainGroup.select('text')
        @mainTextXPos = @mainText.select('tspan').attr('x')
        @mainTextYPos = @mainText.select('tspan').attr('y')
        #console.log('@mainText=', @mainText)
        @expandedGuideLeftCircle = @svg.select('#expanded_guide_left')
        @expandedGuideMiddleCircle = @svg.select('#expanded_guide_middle')
        @expandedGuideRightCircle = @svg.select('#expanded_guide_right')

        return

    clearMain: (callback) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('clearMain()')

        transitionDuration = @transitionDuration / 2
        if @currentView is 'mobile'
            transitionDuration = 0
        elems = @mainText.selectAll('tspan')
        count = elems.size()
        if count
            if __DEV__
                if debug
                    console.log('  transitionDuration=', transitionDuration)
                    console.log('  count=', count)
            if transitionDuration is 0
                elems.remove()
                callback()
            else
                elems
                    .attr('opacity', '1')
                    .transition()
                    .duration(transitionDuration)
                    .attr('opacity', '0')
                    .remove()
                    .on('end', () =>
                        callback()
                        return
                    )
        else
            callback()

        return

    pushMain: (callback) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('pushMain()')

        ref = @currentRef
        name = @nodeMap[ref].name

        if __DEV__
            if debug
                console.log('  ref=', ref)
                console.log('  name=', name)

        #
        # wrap text
        #
        if 1
            width = @mainCircle.attr('r')
            x = @mainTextXPos
            y = @mainTextYPos
            #console.log('x=', x)
            #console.log('y=', y)
            #console.log(text)
            @mainText.attr('id', ref)
            if 1
                elems = @mainText.selectAll('tspan')
                elems.remove()
                dy = textFlow(name, @mainText.node(), width, x, 27, false);
                count = @mainText.selectAll('tspan').size()
                @mainText.select('tspan')
                    .attr('y', () ->
                        #console.log('  y=', y)
                        #console.log('  dy=', dy)
                        y -= ((count - 1) * 27) / 2  # vertical center
                        #console.log('  y=', y)
                        return y
                )
        #console.log(dy)
        #console.log(@mainText.node())
        if callback
            callback()

        return

    setupDefinition: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('setupDefinition()')

        @definitionGroup = @svg.select('g#definition')
        @definitionBox = @definitionGroup.select('#definition_box')
        @definitionHeading = @definitionGroup.select('#definition_heading')
        @definitionTerm = @definitionGroup.select('#definition_term')
        if 0
            @definitionTermXPos = @definitionTerm.select('tspan').attr('x')
        @definitionText = @definitionGroup.select('#definition_text')
        if 0
            @definitionTextXPos = @definitionText.select('tspan').attr('x')
        @definitionXLink = @definitionGroup.select('#definition_xlink')
        @definitionLink = @definitionGroup.select('#definition_link')
        if 0
            if 0
                @definitionLinkXPos = @definitionLink.select('tspan').attr('x')
            else
                @definitionLinkXPos = @definitionLink.attr('x')

        return

    clearDefinition: (callback) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('clearDefinition()')

        @htmlDefinition.splice(0, @htmlDefinition.length)
        #@definitionGroup.classed('inactive', true)
        @definitionTerm.selectAll('tspan').remove()
        @definitionText.selectAll('tspan').remove()
        @definitionLink.selectAll('tspan').remove()
        callback()

        return

    pushDefinition: (callback) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('pushDefinition()')

        ref = @currentRef
        name = @nodeMap[ref].name
        definition = @nodeMap[ref].definition
        href = reactive('<div href="' + global['urls']['content'] + '" />', {name: encodeURI(name), ref: ref}).el.getAttribute('href')
        if __DEV__
            if debug
                console.log('  ref=', ref)
                console.log('  name=', name)
                console.log('  definition=', definition)
                console.log('  href=', href)
        try
            # NOTE: firefox throws here when hidden
            bbox = @definitionBox.node().getBBox()
        catch err
            #console.error(err)
            bbox = {x: 100, y: 100, width: 100, height: 100}
        text_width = bbox.width
        #console.log('text_width=', text_width)
        backup_attribute_name = 'data-backup-x' + '-' + @currentView
        if not @definitionText.attr(backup_attribute_name)
            x = @definitionText.attr('x')
            @definitionText.attr(backup_attribute_name, x)
        text_x = @definitionText.attr(backup_attribute_name)
        if 0
            # NOTE: use for left aligned
            padding = (text_x - bbox.x)
            text_width -= padding * 2
        else
            # NOTE: use for centered aligned
            if 0
                padding = 20
                text_width -= padding * 2
            else
                if @currentView is 'mobile'
                    padding = (bbox.width * .15)
                else
                    padding = (bbox.width * .1)
                text_width -= padding
        #console.log('bbox.x=', bbox.x)
        #console.log('bbox.width=', bbox.width)
        #console.log('padding=', padding)
        #console.log('text_width=', text_width)

        if 1
            x = @definitionTerm.attr('x')
            h = parseInt(@definitionTerm.attr('font-size'), 10)
            h *= 1.25
            @definitionTerm.selectAll('tspan').remove()
            dy = textFlow(name, @definitionTerm.node(), text_width, x, h, false);

        if 1
            x = text_x
            h = parseInt(@definitionText.attr('font-size'), 10)
            h *= 1.25
            @definitionText.selectAll('tspan').remove()
            dy = textFlow(definition, @definitionText.node(), text_width, x, h, false);
            if 1
                #
                # center if not wrapped
                #
                tspanNodes = @definitionText.selectAll('tspan')
                if tspanNodes.size() is 1
                    @definitionText.classed('centered', true)
                    # x = 610
                    x = 0
                else
                    @definitionText.classed('centered', false)
                    x = @definitionText.attr(backup_attribute_name)
                @definitionText.attr('x', x)
                tspanNodes.attr('x', x)
            if 1
                @resizeBox(@definitionText.node(), true, 0)

        if 1
            if ref
                tabindex = @definitionXLink.attr('data-tabindex')
                link_text = 'Search all content on ' + name
                x = @definitionLink.attr('x')
                h = parseInt(@definitionLink.attr('font-size'), 10)
                h *= 1.25
                @definitionLink.selectAll('tspan').remove()
                dy = textFlow(link_text, @definitionLink.node(), text_width, x, h, false);
                @definitionXLink
                    .attr('xlink:href', (d, i) =>
                        return href
                    )
                    .attr('aria-label', 'Methods Map has been updated below, ' + link_text)
                if @forceTabIndex
                    @definitionXLink.attr('tabindex', tabindex)
                else
                    @definitionXLink.attr('tabindex', null)
                #if 'focus' of @definitionXLink.node()
                #    @definitionXLink.node().focus()
            else
                @definitionXLink.attr('tabindex', -1)
            #console.log(@definitionXLink.node())

        if @currentView isnt 'mobile'
            # NOTE: shift term heading and contents based on term/no-term
            d3.selectAll('[data-term-list]')
                .attr('null', () ->
                    for name in this.getAttribute('data-term-list').split(';')
                        if not name
                            continue
                        # console.log('name=', name)
                        # NOTE: binary value
                        values = this.getAttribute('data-term-' + name).split('|')
                        if ref
                            value = values[0]
                        else
                            value = values[1]
                        # console.log('name=', name, 'value=', value, typeof(value))
                        this.setAttribute(name, value)
                    return null
                )

        if callback
            callback()

        @htmlDefinition.push({title: name, text: definition, href: href, ref: ref})

        @focusDefinition()

        return

    focusDefinition: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('focusDefinition()')
                console.log('  @accessibilityMode=', @accessibilityMode)

        link_node = null
        if @accessibilityMode
            # NOTE: definition is dynamically recreated so can't memoize node
            # NOTE: href changes based on "Search all..." visibility (see title_link click event above)
            link_node = @htmlContainer.querySelector('.accessible-definition-name > a')
        else
            if @definitionXLink
                link_node = @definitionXLink.node()
        if __DEV__
            if debug
                console.log('  link_node=', link_node)
        if link_node and 'focus' of link_node
            if __DEV__
                if debug
                    console.log('  link_node.focus()')
                    console.log('  document.activeElement(before)=', document.activeElement)
            link_node.focus()
            if __DEV__
                if debug or 0
                    console.log('  document.activeElement(after)=', document.activeElement)
                    setTimeout(() =>
                        console.log('  document.activeElement(after)=', document.activeElement)
                        return
                    , 1000)

        return

    setupBack: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('setupBack()')

        that = this
        @narrowerBackNode = @svg.select('g#back')
            .on('click', (event) =>
                #console.log('event=', event)
                if @transitionInProgress
                    return
                @transitionInProgress = true
                #if @debugTransitions
                #    console.log('  setting @transitionInProgress to', JSON.stringify(@transitionInProgress))
                @toggleExpandedView(null, event, () =>
                    @transitionInProgress = false
                    #if @debugTransitions
                    #    console.log('  setting @transitionInProgress to', JSON.stringify(@transitionInProgress))
                    return
                )
                return
            )
        if __DEV__
            if debug
                console.log('  @narrowerBackNode=', @narrowerBackNode)

        return

    setupViewMore: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('setupViewMore()')

        that = this
        @svg.select('#view_more_rect')
            .on('click', (event) =>
                #console.log('event=', event)
                if @transitionInProgress
                    return
                @transitionInProgress = true
                #if @debugTransitions
                #    console.log('  setting @transitionInProgress to', JSON.stringify(@transitionInProgress))
                @toggleExpandedView(that.narrowerGroup.node(), event, () =>
                    @transitionInProgress = false
                    #if @debugTransitions
                    #    console.log('  setting @transitionInProgress to', JSON.stringify(@transitionInProgress))
                    return
                )
                return
            )
        @narrowerViewMore = @svg.select('g#view_more')
        if __DEV__
            window.narrowerViewMore = @narrowerViewMore

        return

    setupNarrowerChildren: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('setupNarrowerChildren()')

        that = this
        @narrowerGroup = @svg.select('#narrower')
        @narrowerCircleGroup = @narrowerGroup.select('g.circle-group')
        #@narrowerCircle = @narrowerCircleGroup.select('circle.circle')
        #console.log('@narrowerCircle=', @narrowerCircle.node())
        @narrowerCircleGroup
            .on('mouseover', @toggleHover)
            .on('mouseout', @toggleHover)
        hammer = new Hammer(@narrowerCircleGroup.node())
        hammer.on('tap', (event) =>
            event.preventDefault()
            #event.stopPropagation()
            @focusBubble(event.target.parentNode.parentNode.id, event)
            return
        )
        # inner/outer rings
        if 0
            @narrowerGroupLayer1 = @narrowerGroup.insert('g', ':first-child')
                .attr('class', 'narrower-child')
        else
            @narrowerGroupLayer1 = @narrowerGroup.select('g.narrower-child')
        if 0
            @narrowerChildBubbleRing = @narrowerGroupLayer1.append('circle')
                .attr('class', 'node-ring')
                .attr('r', @narrowerChildBubbleRingRadius)
            @narrowerChildTextRing = @narrowerGroupLayer1.append('circle')
                .attr('class', 'text-ring')
                .attr('r', @narrowerChildTextRingRadius)

        return

    clearNarrowerChildren: (callback) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('clearNarrowerChildren()')

        #console.log('before clearing @htmlNarrowerBubbleTerms=', JSON.stringify(@htmlNarrowerBubbleTerms, null, 2))
        @htmlNarrowerBubbleTerms.splice(0, @htmlNarrowerBubbleTerms.length)
        #console.log('after clearing @htmlNarrowerBubbleTerms=', JSON.stringify(@htmlNarrowerBubbleTerms, null, 2))

        transitionDuration = @transitionDuration / 2
        if @currentView is 'mobile'
            transitionDuration = 0
        @narrowerGroup.classed('inactive', true)
        if @currentView is 'mobile'
            @narrowerGroup.classed('selected', false)
        @narrowerGroupLayer1.selectAll('circle.child')
            .transition()
            .attr('cx', 0)
            .attr('cy', 0)
            .duration(transitionDuration)
        @narrowerGroupLayer1.selectAll('line.child')
            .transition()
            .attr('x2', 0)
            .attr('y2', 0)
            .duration(transitionDuration)
        @narrowerGroupLayer1.selectAll('text.child')
            .transition()
            .attr('x', 0)
            .attr('y', 0)
            .duration(transitionDuration)
        elems = @narrowerGroupLayer1.selectAll('g.node')
        count = elems.size()
        if count
            if __DEV__
                if debug
                    console.log('  transitionDuration=', transitionDuration)
                    console.log('  count=', count)
            if transitionDuration is 0
                elems.remove()
                @repositionNarrowerChildren()
                callback()
            else
                elems
                    .transition()
                    .remove()
                    .duration(transitionDuration)
                    .on('end', () =>
                        if __DEV__
                            if debug
                                console.log('  removed')
                        count -= 1
                        if count is 0
                            if __DEV__
                                if debug or 0
                                    console.log('  after:', @narrowerGroupLayer1.selectAll('g.node').size())
                            @repositionNarrowerChildren()
                            callback()
                        return
                    )
        else
            callback()

        return

    pushNarrowerChildren: (callback) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('pushNarrowerChildren()')
                console.log('  @currentRef=', @currentRef)
                console.log('  @expandedView=', @expandedView)

        ref = @currentRef
        node = @nodeMap[ref]
        if __DEV__
            if debug
                console.log('  node=', node)
        @narrowerViewMore
            .classed('active', false)
        if not node or not node.children or node.children.length is 0
            if @currentView is 'mobile'
                @broaderGroup.classed('selected', true)
            if callback
                callback()
            return
        @narrowerGroup.classed('inactive', false)
        tabindex = parseInt(@narrowerGroup.attr('data-starting-tabindex'), 10)
        #console.log('tabindex=', tabindex, typeof(tabindex))
        #if @currentView is 'mobile'
        #    @narrowerGroup.classed('selected', true)
        #console.log(node.children)
        for childRef, i in node.children
            #console.log(i)
            #console.log(childRef)
            @pushNarrowerChild(childRef, tabindex + i)
        @narrowerGroup.select('g.node:first-child a')
            .classed('first-child', true)
        @narrowerGroup.select('g.node:last-child a')
            .classed('last-child', true)

        if callback
            callback()

        return

    repositionNarrowerChildren: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('repositionNarrowerChildren()')

        that = this

        transitionDuration = @transitionDuration
        if @currentView is 'mobile'
            step = 40  # line height
            transitionDuration = 0
        else
            count = 0
            if @expandedView
                maxNodes = Infinity
            else
                maxNodes = @maxNodes
            groupNodes = @narrowerGroupLayer1.selectAll('g.node')
            groupNodes
                .attr('null', () ->
                    #console.log('count=', count)
                    count += 1
                    node = d3.select(this)
                    if count > maxNodes
                        #console.log('  hiding')
                        node.classed('hidden', true)
                    else
                        #console.log('  showing')
                        node.classed('hidden', false)
                    return null
                )
            #console.log('count', count)
            if count > maxNodes
                @narrowerViewMore
                    .classed('active', true)
            if not @expandedView
                count = Math.min(@maxNodes, count)
            #console.log('  count=', count)

            angle_center = 180
            angle_range = 180
            if @expandedView
                angle_center = 180
                angle_range = 360

            #
            # create angle steps
            #
            step = 360 / (count + 1)
            #console.log('  step=', step)

            half = angle_range / 2
            range = [angle_center - half, angle_center + half]
            #console.log('range=', range)
            scale = d3.scaleLinear().domain([0,360]).range(range)

            # x = cx + r * cos(a)
            # y = cy + r * sin(a)
            # Where r is the radius, cx,cy the origin, and a the angle.

        #
        # bubbles
        #
        a = step
        @narrowerGroupLayer1.selectAll('circle.child')
            .attr('null', (d, i) ->
                #console.log(this)
                groupLayer = this.groupLayer
                groupLayer.circle = {}
                groupLayer.text = {}
                #console.log(d3.select(this.parentNode))
                if that.currentView is 'mobile'
                    x = groupLayer.circle.x = groupLayer.text.x = 10
                    y = groupLayer.circle.y = groupLayer.text.y = a
                    groupLayer.text.x += 15
                else
                    aScaled =  scale(a)
                    #console.log('    a=', a)
                    #console.log('    aScaled=', aScaled)
                    radians = (aScaled - 180) * Math.PI / 180
                    groupLayer.radians = radians
                    #console.log('    radians=', radians)
                    r = that.narrowerChildBubbleRingRadius
                    x = groupLayer.circle.x = r * Math.cos(radians)
                    y = groupLayer.circle.y = r * Math.sin(radians)
                    r2 = that.narrowerChildTextRingRadius
                    groupLayer.text.x = r2 * Math.cos(radians)
                    groupLayer.text.y = r2 * Math.sin(radians)
                #console.log('  x=', x, 'y=', y)
                d3.select(this)
                    .transition()
                    .attr('cx', x)
                    .attr('cy', y)
                    .duration(transitionDuration)
                a += step
                return null
            )

        #
        # lines
        #
        a = step
        @narrowerGroupLayer1.selectAll('line.child')
            .attr('null', (d, i) ->
                #console.log('  reset')
                #console.log(this)
                groupLayer = this.groupLayer
                x = groupLayer.circle.x
                y = groupLayer.circle.y
                d3.select(this)
                    .transition()
                    .attr('x2', x)
                    .attr('y2', y)
                    .duration(transitionDuration)
                a += step
                return null
            )

        #
        # text
        #
        a = step
        text = @narrowerGroupLayer1.selectAll('text.child')
        count = text.size()
        #console.log('count=', count)
        text
            #.attr('data-mobile-adjust-height-xpath', '#narrower g.mobile-node-box path')
            .attr('null', (d, i) ->
                #console.log(this)
                groupLayer = this.groupLayer
                x = groupLayer.text.x
                y = groupLayer.text.y
                #console.log('x=', x, 'y=', y)
                d3.select(this)
                    .transition()
                    .attr('x', x)
                    .attr('y', y)
                    .attr('text-anchor', that.getTextAnchor(x))
                    #.attr('data-item-name', that.nodeMap[this.ref].name + ' (' + that.nodeMap[this.ref].count + ')')  # NOTE: dataLayer
                    .duration(transitionDuration)
                    .on('end', () ->
                        count -= 1
                        that.resizeBox(that.narrowerGroupLayer1.node(), false, 0)
                        if count is 0
                            if 0
                                that.resizeNodeBox(that.narrowerGroupLayer1)
                            else if that.currentView is 'mobile'
                                #events.emit('click', that.narrowerCircle.node())
                                console.log('event?', this)
                                that.focusBubble(that.narrowerGroup.node().id, this)
                        if that.currentView isnt 'mobile'
                            that.abbreviateTextNode(this)
                        return
                    )
                a += step
                return null
            )
        text.select('tspan.name')
            .text(() ->
                text = that.nodeMap[this.ref].name
                this.parentNode.setAttribute('data-item-name', text) # NOTE: dataLayer
                return text
            )

        return

    abbreviateTextNode: (node) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('abbreviateNodeName()')
                console.log('  node=', node)

        # NOTE: implemented from https://gvpicom.atlassian.net/browse/SRM-1355
        that = this
        d3node = d3.select(node)
        text = d3node.attr('data-item-name')
        if __DEV__
            if debug
                console.log('  text=', text)
                console.log('  d3node=', d3node)
        d3node.select('tspan.name').text(() ->
            #if text isnt 'Data quality and data management'
            #    return
            #debug = 1
            if __DEV__
                if debug
                    console.log('  text=', text)
            max_length = null
            group_layer = node.groupLayer
            radians = group_layer.radians
            if __DEV__
                if debug
                    console.log('  radians=', radians)
            degrees = radians * (180 / Math.PI)
            degrees = Math.abs(Math.round(degrees))
            if __DEV__
                if debug
                    console.log('  degrees=', degrees)
            if 0
                # NOTE: cutoff based on hardcoded ranges
                if degrees in [0..29]
                    max_length = 20
                else if degrees in [30..59]
                    max_length = 25
                else if degrees in [60..90]
                    max_length = 30
                if __DEV__
                    if debug
                        console.log('  max_length=', max_length)
                if max_length and text.length > max_length
                    text = text.substring(0, max_length) + that.ellipses
            else
                # NOTE: cutoff based on length and position; perfect rendering
                svg_node = that.svg.node()
                svg_bounds = svg_node.getBoundingClientRect()
                text_node = node.parentNode
                text_bounds = text_node.getBoundingClientRect()
                text_bounds3 = text_node.getClientRects()
                #text_bounds2 = text_node.getBBox()  # NOTE: firefox throws here when hidden but not needed anyway
                if __DEV__
                    if debug
                        console.log('--------------------------------')
                        console.log(text)
                        console.log('  radians=', radians)
                        console.log('  text_node=', text_node)
                        #console.log('  svg_node=', svg_node)
                        #console.log('    svg_bounds=', svg_bounds)
                        #console.log('    svg_bounds.width=', svg_bounds.width)
                        console.log('    svg_bounds.left=', svg_bounds.left)
                        console.log('    svg_bounds.right=', svg_bounds.right)
                        #console.log('  text_bounds=', text_bounds)
                        #console.log('  text_bounds2=', text_bounds2)
                        #console.log('  text_bounds3=', text_bounds3)
                        console.log('    text_bounds.left=', text_bounds.left)
                        console.log('    text_bounds.right=', text_bounds.right)
                        console.log('    text_bounds.width=', text_bounds.width)
                        #console.log('    text_bounds.left + text_bounds.width=', text_bounds.left + text_bounds.width)
                        #console.log('  window.innerWidth=', window.innerWidth)
                if (radians >= 0 and text_bounds.right > svg_bounds.right) or (radians < 0 and text_bounds.left < svg_bounds.left)
                    if radians >= 0
                        diff = text_bounds.right - svg_bounds.right
                    else
                        diff = text_bounds.left - svg_bounds.left
                    diff = Math.abs(diff)
                    if __DEV__
                        if debug
                            console.log('  diff=', diff)
                    p = 1 - (diff / text_bounds.width)
                    if __DEV__
                        if debug
                            console.log('  p=', p)
                    text_length = text.length
                    if __DEV__
                        if debug
                            console.log('  text_length=', text_length)
                            console.log('  text_length * p =', text_length * p)
                    new_text_length = Math.floor(text_length * p)
                    if __DEV__
                        if debug
                            console.log('  new_text_length=', new_text_length)
                    new_text_length -= that.ellipses.length
                    new_text = text.substring(0, new_text_length)
                    if __DEV__
                        if debug
                            console.log('  new_text=', new_text)
                    new_text += that.ellipses
                    if __DEV__
                        if debug
                            console.log('  new_text=', new_text)
                    text = new_text

            return text
        )

        return

    pushNarrowerChild: (ref, tabindex) =>

        if __DEV__
            debug = @debug or 0
            if debug or 0
                console.log('pushNarrowerChild()')

        that = @
        node = @nodeMap[ref]
        if __DEV__
            if debug
                console.log('  node=', node)

        slug_name = slug(node.name)
        #url = location.href.replace(/\/$/, "") + '/' + slug_name
        url = '/'
        if window['srm']['localhost']
            url += 'srm3.0/'
        url += 'methods-map/'
        url += slug_name

        name = node.name

        dx = 0
        dy = 0
        if @currentView is 'mobile'
            dx = 0
            dy = 30
        #console.log('  dx=', dx, 'dy=', dy)

        if __DEV__
            if debug
                console.log('  name=', name)
                console.log('  slug_name=', slug_name)
                console.log('  url=', url)

        #
        # group
        #
        groupLayer = @narrowerGroupLayer1.append('g')
            .attr('class', 'node')
            .attr('id', ref)
            # .attr('aria-labelledby', ref + '_title')
        if 0
            title = groupLayer.append('title')
                .text(name)
                # .attr('id', ref + '_title')

        #
        # lines
        #
        if @currentView isnt 'mobile'
            line = groupLayer.insert('line', 'circle')
            line
                .attr('class', 'child')
                .attr('null', (d, i) ->
                    #console.log(this)
                    this.ref = ref
                    this.circle = circle
                    this.groupLayer = groupLayer
                    return null
                )
                .attr('x2', dx)
                .attr('y2', dy)
                .on('click', (event) ->
                    #console.log('event=', event)
                    that.focusNode(this.ref)
                    return
                )

        #
        # bubbles
        #
        circle = groupLayer.append('circle')
        circle
            .attr('class', 'child')
            .attr('r', (d, i) ->
                #console.log(this)
                this.ref = ref
                this.circle = circle
                this.groupLayer = groupLayer
                if that.currentView is 'mobile'
                    this.radii = [3, 5]
                else
                    this.radii = [6, 8]
                return this.radii[0]
            )
            .attr('cx', dx)
            .attr('cy', dy)
            .attr('alt', () ->
                return name
            )
            .attr('aria-label', () ->
                return name
            )
            .on('click', (event) ->
                #console.log('event=', event)
                that.focusNode(this.ref)
                return
            )
            .on('mouseover', @toggleHover)
            .on('mouseout', @toggleHover)

        #
        # xlink
        #
        xlink = groupLayer.append('a')
            .attr('xlink:href', () ->
                if 0
                    # NOTE: moved above
                    slug_name = slug(node.name)
                    #url = location.href.replace(/\/$/, "") + '/' + slug_name
                    url = '/'
                    if window['srm']['localhost']
                        url += 'srm3.0/'
                    url += 'methods-map/'
                    url += slug_name
                    #console.log('url=', url)
                return url
            )
            .attr('null', (d, i) ->
                this.ref = ref
                this.circle = circle
                this.groupLayer = groupLayer
                return null
            )
            .on('click', (event) ->
                #console.log('event=', event)
                that.focusNode(this.ref)
                return
            )
            .on('mouseover', @toggleHover)
            .on('mouseout', @toggleHover)
        if @forceTabIndex
            xlink.attr('tabindex', tabindex)
        xlink.node().addEventListener('click', (event) ->
            # NOTE: needed to grab event, isn't passed in .on() above
            event.preventDefault()
            event.stopPropagation()
            return false
        )
        # NOTE: narrower
        xlink.node().addEventListener('keydown', (event) ->
            if event.which is 9 and event.shiftKey and event.target.classList.contains('first-child')
                # NOTE: exiting bubbles into either broader or definition or outside svg if no broader or defintion
                # NOTE: reset view
                # NOTE: get broader count
                count = that.broaderGroupLayer1.selectAll('g.node').size()
                # console.log('broader count=', count)
                if count is 0
                    that.focusBubble(null, event)
                if 1
                    # NOTE: reset view_more if needed
                    count = that.narrowerGroupLayer1.selectAll('g.node').size()
                    if count > that.maxNodes and not that.narrowerViewMore.classed('active')
                        # that.svg.select('#view_more_rect').node().click()
                        events.emit('click', that.svg.select('#view_more_rect').node())
                return
            if event.which is 9 and not event.shiftKey and event.target.classList.contains('last-child')
                # NOTE: exiting bubbles into either related or history or outside svg if no related or history
                # NOTE: reset view
                # NOTE: get related count
                count = that.relatedGroupLayer1.selectAll('g.node').size()
                # console.log('related count=', count)
                if count is 0
                    that.focusBubble(null, event)
                if 1
                    # NOTE: reset view_more if needed
                    count = that.narrowerGroupLayer1.selectAll('g.node').size()
                    if count > that.maxNodes and not that.narrowerViewMore.classed('active')
                        # that.svg.select('#view_more_rect').node().click()
                        events.emit('click', that.svg.select('#view_more_rect').node())
                return
        )
        xlink.node().addEventListener('keyup', (event) ->
            if event.which isnt 9
                return
            if 0
                console.log('focus narrower')
                console.log(event.target)
            # if 1 or this.groupLayer.classed('hidden')
                # console.log('hidden!')
                # that.svg.select('#view_more_rect').node().click()
                # events.emit('click', that.svg.select('#view_more_rect').node())
                # that.toggleExpandedView()
            if 0
                console.log('that.narrowerGroup.classed("expanded")=', that.narrowerGroup.classed('expanded'))
            if not that.narrowerGroup.classed('expanded')
                if 1
                    that.toggleExpandedView(that.narrowerGroup.node(), event, () =>
                        that.transitionInProgress = false
                        #if that.debugTransitions
                        #    console.log('  setting that.transitionInProgress to', JSON.stringify(that.transitionInProgress))
                        if that.narrowerViewMore.classed('active')
                            # that.svg.select('#view_more_rect').node().click()
                            events.emit('click', that.svg.select('#view_more_rect').node())
                        return
                    )
                else
                    that.focusBubble('narrower', event, () =>
                        # if that.svg.select('#view_more').classed('active')
                        if that.narrowerViewMore.classed('active')
                            # that.svg.select('#view_more_rect').node().click()
                            events.emit('click', that.svg.select('#view_more_rect').node())
                        return
                    )
            # return
        )

        #
        # text
        #
        #text = groupLayer.append('text')
        text = xlink.append('text')
        text
            .attr('class', 'child')
            .attr('null', (d, i) ->
                #console.log(this)
                this.ref = ref
                this.circle = circle
                this.groupLayer = groupLayer
                return null
            )
            .attr('x', dx)
            .attr('y', dy)
            #.on('click', () ->
            #    that.focusNode(this.ref)
            #    return
            #)
            #.on('mouseover', @toggleHover)
            #.on('mouseout', @toggleHover)
        tspan = text.append('tspan')
            .attr('class', 'name')
            .attr('null', (d, i) ->
                #console.log(this)
                this.ref = ref
                this.circle = circle
                this.groupLayer = groupLayer
                return null
            )
            .text(name)
        if __DEV__
            if debug or 0
                console.log('  tspan=', tspan)

        term = {title: name, href: url, ref: ref}
        #console.log('before adding', term, 'to @htmlNarrowerBubbleTerms=', JSON.stringify(@htmlNarrowerBubbleTerms, null, 2))
        @htmlNarrowerBubbleTerms.push(term)
        #console.log('after adding @htmlNarrowerBubbleTerms=', JSON.stringify(@htmlNarrowerBubbleTerms, null, 2))

        return

    setupBroaderChildren: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('setupBroaderChildren()')

        that = this
        @broaderGroup = @svg.select('#broader')
        @broaderCircleGroup = @broaderGroup.select('g.circle-group')
        #@broaderCircle = @broaderCircleGroup.select('circle.circle')
        #console.log('@broaderCircle=', @broaderCircle.node())
        @broaderCircleGroup
            .on('mouseover', @toggleHover)
            .on('mouseout', @toggleHover)
        hammer = new Hammer(@broaderCircleGroup.node())
        hammer.on('tap', (event) =>
            event.preventDefault()
            #event.stopPropagation()
            @focusBubble(event.target.parentNode.parentNode.id, event)
            return
        )
        # inner/outer rings
        if 0
            @broaderGroupLayer1 = @broaderGroup.insert('g', ':first-child')
                .attr('class', 'broader-child')
        else
            @broaderGroupLayer1 = @broaderGroup.select('g.broader-child')
        if 0
            @broaderChildBubbleRing = @broaderGroupLayer1.append('circle')
                .attr('class', 'node-ring')
                .attr('r', @broaderChildBubbleRingRadius)
            @broaderChildTextRing = @broaderGroupLayer1.append('circle')
                .attr('class', 'text-ring')
                .attr('r', @broaderChildTextRingRadius)
        if 0
            @broaderLineLayer = @broaderGroup.insert('g', ':first-child')
                .attr('class', 'broader-child')
            @broaderGradientCircle = @broaderLineLayer.append('circle')
                .attr('class', 'node-gradient')
                .attr('r', @broaderChildBubbleRingRadius)
        return

    clearBroaderChildren: (callback) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('clearBroaderChildren()')

        #console.log('before clearing @htmlBroaderBubbleTerms=', JSON.stringify(@htmlBroaderBubbleTerms, null, 2))
        @htmlBroaderBubbleTerms.splice(0, @htmlBroaderBubbleTerms.length)
        #console.log('after clearing @htmlBroaderBubbleTerms=', JSON.stringify(@htmlBroaderBubbleTerms, null, 2))

        transitionDuration = @transitionDuration / 2
        if @currentView is 'mobile'
            transitionDuration = 0
        @broaderGroup.classed('inactive', true)
        if @currentView is 'mobile'
            @broaderGroup.classed('selected', false)
        @broaderGroupLayer1.selectAll('circle.parent')
            .transition()
            .attr('cx', 0)
            .attr('cy', 0)
            .duration(transitionDuration)
        @broaderGroupLayer1.selectAll('line.parent')
            .transition()
            .attr('x2', 0)
            .attr('y2', 0)
            .duration(transitionDuration)
        @broaderGroupLayer1.selectAll('text.parent')
            .transition()
            .attr('x', 0)
            .attr('y', 0)
            .duration(transitionDuration)
        elems = @broaderGroupLayer1.selectAll('g.node')
        count = elems.size()
        if count
            if __DEV__
                if debug
                    console.log('  transitionDuration=', transitionDuration)
                    console.log('  count=', count)
            if transitionDuration is 0
                elems.remove()
                @repositionBroaderChildren()
                callback()
            else
                elems
                    .transition()
                    .duration(transitionDuration)
                    .remove()
                    .on('end', () =>
                        count -= 1
                        if count is 0
                            @repositionBroaderChildren()
                            callback()
                        return
                    )
        else
            callback()

        return

    pushBroaderChildren: (callback) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('pushBroaderChildren()')
                console.log('  @currentRef=', @currentRef)
                console.log('  @expandedView=', @expandedView)

        ref = @currentRef
        node = @nodeMap[ref]
        if __DEV__
            if debug
                console.log('  node=', node)
        if not node or not node.parents or node.parents.length is 0
            if callback
                callback()
            return
        @broaderGroup.classed('inactive', false)
        tabindex = parseInt(@broaderGroup.attr('data-starting-tabindex'), 10)
        for parentRef, i in node.parents
            #console.log('  parentRef=', parentRef)
            @pushBroaderChild(parentRef, tabindex + i)
        @broaderGroup.select('g.node:first-child a')
            .classed('first-child', true)
        @broaderGroup.select('g.node:last-child a')
            .classed('last-child', true)
        if callback
            callback()

        return

    repositionBroaderChildren: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('repositionBroaderChildren()')

        that = this

        transitionDuration = @transitionDuration
        if @currentView is 'mobile'
            step = 40  # line height
            transitionDuration = 0
        else
            groupNodes = @broaderGroupLayer1.selectAll('g.node')
            count = 0
            if @expandedView
                maxNodes = Infinity
            else
                maxNodes = @maxNodes
            groupNodes
                .attr('null', () ->
                    #console.log('count=', count)
                    count += 1
                    node = d3.select(this)
                    if count > maxNodes
                        #console.log('  hiding')
                        node.classed('hidden', true)
                    else
                        #console.log('  showing')
                        node.classed('hidden', false)
                    return null
                )
            #if count > maxNodes
            #    @narrowerViewMore.attr('class', null)
            if not @expandedView
                count = Math.min(@maxNodes, count)
            #console.log('  count=', count)

            angle_center = 0
            #console.log('  angle_center=', angle_center)
            angle_range = 180
            if @expandedView
                #angle_center = 180
                angle_range = 360
            #console.log('  angle_range=', angle_range)

            #
            # create angle steps
            #
            step = 360 / (count + 1)
            #console.log('  step=', step)
            #angle_center = 0

            half = angle_range / 2
            range = [angle_center - half, angle_center + half]
            #console.log('  range=', range)
            scale = d3.scaleLinear().domain([360,0]).range(range)

            # x = cx + r * cos(a)
            # y = cy + r * sin(a)
            # Where r is the radius, cx,cy the origin, and a the angle.

        #
        # bubbles
        #
        a = step
        @broaderGroupLayer1.selectAll('circle.parent')
            .attr('null', (d, i) ->
                #console.log(this)
                groupLayer = this.groupLayer
                groupLayer.circle = {}
                groupLayer.text = {}
                #console.log(d3.select(this.parentNode))
                if that.currentView is 'mobile'
                    x = groupLayer.circle.x = groupLayer.text.x = 50
                    y = groupLayer.circle.y = groupLayer.text.y = a
                    groupLayer.text.x += 15
                else
                    aScaled =  scale(a)
                    #console.log('    a=', a)
                    #console.log('    aScaled=', aScaled)
                    radians = (aScaled - 180) * Math.PI / 180
                    groupLayer.radians = radians
                    #console.log('    radians=', radians)
                    r = that.broaderChildBubbleRingRadius
                    x = groupLayer.circle.x = r * Math.cos(radians)
                    y = groupLayer.circle.y = r * Math.sin(radians)
                    r2 = that.broaderChildTextRingRadius
                    groupLayer.text.x = r2 * Math.cos(radians)
                    groupLayer.text.y = r2 * Math.sin(radians)
                #console.log('  x=', x, 'y=', y)
                d3.select(this)
                    .transition()
                    .attr('cx', x)
                    .attr('cy', y)
                    .duration(transitionDuration)
                a += step
                return null
            )

        #
        # lines
        #
        a = step
        @broaderGroupLayer1.selectAll('line.parent')
            .attr('null', (d, i) ->
                #console.log('  reset')
                #console.log(this)
                groupLayer = this.groupLayer
                x = groupLayer.circle.x
                y = groupLayer.circle.y
                d3.select(this)
                    .transition()
                    .attr('x2', x)
                    .attr('y2', y)
                    .duration(transitionDuration)
                a += step
                return null
            )

        #
        # text
        #
        a = step
        text = @broaderGroupLayer1.selectAll('text.parent')
        count = text.size()
        text
            .attr('null', (d, i) ->
                #console.log(this)
                groupLayer = this.groupLayer
                x = groupLayer.text.x
                y = groupLayer.text.y
                #console.log('x=', x, 'y=', y)
                d3.select(this)
                    .transition()
                    .attr('x', x)
                    .attr('y', y)
                    .attr('text-anchor', that.getTextAnchor(x))
                    #.attr('data-item-name', that.nodeMap[this.ref].name + ' (' + that.nodeMap[this.ref].count + ')')  # NOTE: dataLayer
                    .duration(transitionDuration)
                    .on('end', () ->
                        count -= 1
                        that.resizeBox(that.broaderGroupLayer1.node(), false, 0)
                        #if count is 0
                        #    if 0
                        #        that.resizeNodeBox(that.broaderGroupLayer1)
                        #    else if that.currentView is 'mobile'
                        #        #events.emit('click', that.broaderCircle.node())
                        #        that.focusBubble(that.broaderCircle.node().id, this)
                        if that.currentView isnt 'mobile'
                            that.abbreviateTextNode(this)
                        return
                    )
                a += step
                return null
            )
        text.select('tspan.name')
            .text(() ->
                text = that.nodeMap[this.ref].name
                this.parentNode.setAttribute('data-item-name', text) # NOTE: dataLayer
                return text
            )

        #tabindex = parseInt(@broaderGroup.attr('data-starting-tabindex'), 10)
        #@broaderGroupLayer1.selectAll('a')
        #    .attr('tabindex', (d, i) ->
        #        return tabindex + i
        #    )

        return

    pushBroaderChild: (ref, tabindex) =>

        if __DEV__
            debug = @debug or 0
            if debug or 0
                console.log('pushBroaderChild()')
                console.log('  ref=', ref)
                console.log('  tabindex=', tabindex)

        node = @nodeMap[ref]
        that = this
        #console.log('  node=', node)

        slug_name = slug(node.name)
        #url = location.href.replace(/\/$/, "") + '/' + slug_name
        url = '/'
        if window['srm']['localhost']
            url += 'srm3.0/'
        url += 'methods-map/'
        url += slug_name

        name = node.name
        dx = 0
        dy = 0
        if @currentView is 'mobile'
            dx = 50
            dy = 40
        #console.log('  dx=', dx, 'dy=', dy)

        #
        # group
        #
        groupLayer = @broaderGroupLayer1.append('g')
            .attr('class', 'node')
            .attr('id', ref)
        #lineLayer = @broaderLineLayer.insert('g', ':first-child')
        #    .attr('class', 'node')
        #    #.attr('id', ref)
        if 0
            title = groupLayer.append('title')
                .text(name)

        #
        # bubbles
        #
        circle = groupLayer.append('circle')
        circle
            .attr('class', 'parent')
            .attr('r', (d, i) ->
                #console.log(this)
                this.ref = ref
                this.circle = circle
                this.groupLayer = groupLayer
                #this.lineLayer = lineLayer
                if that.currentView is 'mobile'
                    this.radii = [3, 5]
                else
                    this.radii = [6, 8]
                return this.radii[0]
            )
            .attr('cx', dx)
            .attr('cy', dy)
            .attr('alt', () ->
                return name
            )
            .attr('aria-label', () ->
                return name
            )
            .on('click', (event) ->
                #console.log('event=', event)
                that.focusNode(this.ref)
                return
            )
            .on('mouseover', @toggleHover)
            .on('mouseout', @toggleHover)

        #
        # lines
        #
        if @currentView isnt 'mobile'
            line = groupLayer.insert('line', 'circle')
            #line = lineLayer.insert('line', 'circle')
            line
                .attr('class', 'parent')
                .attr('null', (d, i) ->
                    #console.log(this)
                    this.ref = ref
                    this.circle = circle
                    this.groupLayer = groupLayer
                    #this.lineLayer = lineLayer
                    return null
                )
                .attr('x2', dx)
                .attr('y2', dy)
                .on('click', (event) ->
                    #console.log('event=', event)
                    that.focusNode(this.ref)
                    return
                )

        #
        # xlink
        #
        xlink = groupLayer.append('a')
            .attr('xlink:href', () ->
                if 0
                    # NOTE: moved above
                    slug_name = slug(node.name)
                    #url = location.href.replace(/\/$/, "") + '/' + slug_name
                    url = '/'
                    if window['srm']['localhost']
                        url += 'srm3.0/'
                    url += 'methods-map/'
                    url += slug_name
                    #console.log('url=', url)
                return url
            )
            .attr('null', (d, i) ->
                this.ref = ref
                this.circle = circle
                this.groupLayer = groupLayer
                return null
            )
            .on('click', (event) ->
                #console.log('event=', event)
                that.focusNode(this.ref)
                return
            )
            .on('mouseover', @toggleHover)
            .on('mouseout', @toggleHover)
        if @forceTabIndex
            xlink.attr('tabindex', tabindex)
        xlink.node().addEventListener('click', (event) ->
            # NOTE: needed to grab event, isn't passed in .on() above
            event.preventDefault()
            event.stopPropagation()
            return false
        )
        # NOTE: broader
        xlink.node().addEventListener('keydown', (event) ->
            if event.which is 9 and event.shiftKey and event.target.classList.contains('first-child')
                # NOTE: exiting bubbles into either definition or outside svg if no defintion
                # NOTE: reset view
                that.focusBubble(null, event)
                return
        )
        xlink.node().addEventListener('keyup', (event) ->
            if event.which isnt 9
                return
            if 0
                console.log('focus broader')
                console.log(event.target)
            if 0
                console.log('that.broaderGroup.classed("expanded")=', that.broaderGroup.classed('expanded'))
            if not that.broaderGroup.classed('expanded')
                if 1
                    that.toggleExpandedView(that.broaderGroup.node(), event, () =>
                        that.transitionInProgress = false
                        #if that.debugTransitions
                        #    console.log('  setting that.transitionInProgress to', JSON.stringify(that.transitionInProgress))
                        return
                    )
                else
                    that.focusBubble('broader', event)
            return
        )

        #
        # text
        #
        #text = groupLayer.append('text')
        text = xlink.append('text')
        text
            .attr('class', 'parent')
            .attr('null', (d, i) ->
                #console.log(this)
                this.ref = ref
                this.circle = circle
                this.groupLayer = groupLayer
                #this.lineLayer = lineLayer
                return null
            )
            .attr('x', dx)
            .attr('y', dy)
            #.on('click', () ->
            #    that.focusNode(this.ref)
            #    return
            #)
            #.on('mouseover', @toggleHover)
            #.on('mouseout', @toggleHover)
        text.append('tspan')
            .attr('class', 'name')
            .attr('null', (d, i) ->
                #console.log(this)
                this.ref = ref
                this.circle = circle
                this.groupLayer = groupLayer
                return null
            )
            .text(name)

        term = {title: name, href: url, ref: ref}
        #console.log('before adding', term, 'to @htmlBroaderBubbleTerms=', JSON.stringify(@htmlBroaderBubbleTerms, null, 2))
        @htmlBroaderBubbleTerms.push(term)
        #console.log('after adding @htmlBroaderBubbleTerms=', JSON.stringify(@htmlBroaderBubbleTerms, null, 2))

        return

    setupRelatedChildren: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('setupRelatedChildren()')

        that = this
        @relatedGroup = @svg.select('#related')
        @relatedCircleGroup = @relatedGroup.select('g.circle-group')
        #@relatedCircle = @relatedCircleGroup.select('circle.circle')
        #console.log('@relatedCircle=', @relatedCircle.node())
        @relatedCircleGroup
            .on('mouseover', @toggleHover)
            .on('mouseout', @toggleHover)
        hammer = new Hammer(@relatedCircleGroup.node())
        hammer.on('tap', (event) =>
            event.preventDefault()
            #event.stopPropagation()
            @focusBubble(event.target.parentNode.parentNode.id, event)
            return
        )
        # inner/outer rings
        if 0
            @relatedGroupLayer1 = @relatedGroup.insert('g', ':first-child')
                .attr('class', 'related-child')
                #.attr('transform', 'translate(' + @relatedCircle.attr('cx') + ',' + @relatedCircle.attr('cy') + ')')
                .attr('opacity', '0')
        else
            @relatedGroupLayer1 = @relatedGroup.select('g.related-child')
        if 0
            @relatedChildBubbleRing = @relatedGroupLayer1.append('circle')
                .attr('class', 'node-ring')
                .attr('r', @relatedChildBubbleRingRadius)
            @relatedChildTextRing = @relatedGroupLayer1.append('circle')
                .attr('class', 'text-ring')
                .attr('r', @relatedChildTextRingRadius)

        return

    clearRelatedChildren: (callback) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('clearRelatedChildren()')

        #console.log('before clearing @htmlRelatedBubbleTerms=', JSON.stringify(@htmlRelatedBubbleTerms, null, 2))
        @htmlRelatedBubbleTerms.splice(0, @htmlRelatedBubbleTerms.length)
        #console.log('after clearing @htmlRelatedBubbleTerms=', JSON.stringify(@htmlRelatedBubbleTerms, null, 2))

        transitionDuration = @transitionDuration / 2
        if @currentView is 'mobile'
            transitionDuration = 0
        @relatedGroup.classed('inactive', true)
        if @currentView is 'mobile'
            @relatedGroup.classed('selected', false)
        @relatedGroupLayer1.selectAll('circle.sibling')
            .transition()
            .attr('cx', 0)
            .attr('cy', 0)
            .duration(transitionDuration)
        @relatedGroupLayer1.selectAll('line.sibling')
            .transition()
            .attr('x2', 0)
            .attr('y2', 0)
            .duration(transitionDuration)
        @relatedGroupLayer1.selectAll('text.sibling')
            .transition()
            .attr('x', 0)
            .attr('y', 0)
            .duration(transitionDuration)
        elems = @relatedGroupLayer1.selectAll('g.node')
        count = elems.size()
        if count
            if __DEV__
                if debug
                    console.log('  transitionDuration=', transitionDuration)
                    console.log('  count=', count)
            if transitionDuration is 0
                elems.remove()
                @repositionRelatedChildren()
                callback()
            else
                elems
                    .transition()
                    .duration(transitionDuration)
                    .remove()
                    .on('end', () =>
                        count -= 1
                        if count is 0
                            @repositionRelatedChildren()
                            callback()
                        return
                    )
        else
            callback()

        return

    pushRelatedChildren: (callback) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('pushRelatedChildren()')
                console.log('  @currentRef=', @currentRef)
                console.log('  @expandedView=', @expandedView)

        ref = @currentRef
        node = @nodeMap[ref]
        if __DEV__
            if debug
                console.log('  node=', node)
        if not node or not node.related or node.related.length is 0
            if callback
                callback()
            return
        @relatedGroup.classed('inactive', false)
        tabindex = parseInt(@relatedGroup.attr('data-starting-tabindex'), 10)
        for relatedRef, i in node.related
            @pushRelatedChild(relatedRef, tabindex + i)
        @relatedGroup.select('g.node:first-child a')
            .classed('first-child', true)
        @relatedGroup.select('g.node:last-child a')
            .classed('last-child', true)
        if callback
            callback()

        return

    repositionRelatedChildren: () =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('repositionRelatedChildren()')

        that = this

        transitionDuration = @transitionDuration
        if @currentView is 'mobile'
            step = 40  # line height
            transitionDuration = 0
        else
            groupNodes = @relatedGroupLayer1.selectAll('g.node')
            count = 0
            if @expandedView
                maxNodes = Infinity
            else
                maxNodes = @maxNodes
            groupNodes
                .attr('null', () ->
                    #console.log('count=', count)
                    count += 1
                    node = d3.select(this)
                    if count > maxNodes
                        #console.log('  hiding')
                        node.classed('hidden', true)
                    else
                        #console.log('  showing')
                        node.classed('hidden', false)
                    return null
                )
            #if count > maxNodes
            #    @narrowerViewMore.attr('class', null)
            if not @expandedView
                count = Math.min(@maxNodes, count)
            #console.log('  count=', count)

            angle_center = 270
            angle_range = 180
            if @expandedView
                angle_center = 180
                angle_range = 360

            # unique to related; don't show items in non-expanded view
            if @expandedView
                opacity = 1
            else
                opacity = 0
            @relatedGroupLayer1
                .transition()
                .attr('opacity', opacity)
                .duration(transitionDuration)

            #
            # create angle steps
            #
            step = 360 / (count + 1)
            #console.log('  step=', step)

            half = angle_range / 2
            range = [angle_center - half, angle_center + half]
            #console.log('range=', range)
            scale = d3.scaleLinear().domain([0,360]).range(range)

            # x = cx + r * cos(a)
            # y = cy + r * sin(a)
            # Where r is the radius, cx,cy the origin, and a the angle.

        #
        # bubbles
        #
        a = step
        @relatedGroupLayer1.selectAll('circle.sibling')
            .attr('null', (d, i) ->
                #console.log(this)
                groupLayer = this.groupLayer
                groupLayer.circle = {}
                groupLayer.text = {}
                #console.log(d3.select(this.parentNode))
                if that.currentView is 'mobile'
                    x = groupLayer.circle.x = groupLayer.text.x = 10
                    y = groupLayer.circle.y = groupLayer.text.y = a
                    groupLayer.text.x += 15
                else
                    aScaled =  scale(a)
                    #console.log('    a=', a)
                    #console.log('    aScaled=', aScaled)
                    radians = (aScaled - 180) * Math.PI / 180
                    groupLayer.radians = radians
                    #console.log('    radians=', radians)
                    r = that.relatedChildBubbleRingRadius
                    x = groupLayer.circle.x = r * Math.cos(radians)
                    y = groupLayer.circle.y = r * Math.sin(radians)
                    r2 = that.relatedChildTextRingRadius
                    groupLayer.text.x = r2 * Math.cos(radians)
                    groupLayer.text.y = r2 * Math.sin(radians)
                #console.log('  x=', x, 'y=', y)
                d3.select(this)
                    .transition()
                    .attr('cx', x)
                    .attr('cy', y)
                    .duration(transitionDuration)
                a += step
                return null
            )

        #
        # lines
        #
        a = step
        @relatedGroupLayer1.selectAll('line.sibling')
            .attr('null', (d, i) ->
                #console.log(this)
                groupLayer = this.groupLayer
                x = groupLayer.circle.x
                y = groupLayer.circle.y
                d3.select(this)
                    .transition()
                    .attr('x2', x)
                    .attr('y2', y)
                    .duration(transitionDuration)
                a += step
                return null
            )

        #
        # text
        #
        a = step
        text = @relatedGroupLayer1.selectAll('text.sibling')
        count = text.size()
        text
            .attr('null', (d, i) ->
                #console.log(this)
                groupLayer = this.groupLayer
                x = groupLayer.text.x
                y = groupLayer.text.y
                #console.log('x=', x, 'y=', y)
                d3.select(this)
                    .transition()
                    .attr('x', x)
                    .attr('y', y)
                    .attr('text-anchor', that.getTextAnchor(x))
                    #.attr('data-item-name', that.nodeMap[this.ref].name + ' (' + that.nodeMap[this.ref].count + ')')  # NOTE: dataLayer
                    .duration(transitionDuration)
                    .on('end', () ->
                        count -= 1
                        that.resizeBox(that.relatedGroupLayer1.node(), false, 0)
                        #if count is 0
                        #    if 0
                        #        that.resizeNodeBox(that.relatedGroupLayer1)
                        #    else if that.currentView is 'mobile'
                        #        #events.emit('click', that.relatedCircle.node())
                        #        that.focusBubble(that.relatedCircle.node().id, this)
                        if that.currentView isnt 'mobile'
                            that.abbreviateTextNode(this)
                        return
                    )
                a += step
                return null
            )
        text.select('tspan.name')
            .text(() ->
                text = that.nodeMap[this.ref].name
                this.parentNode.setAttribute('data-item-name', text) # NOTE: dataLayer
                return text
            )

        return

    pushRelatedChild: (ref, tabindex) =>

        if __DEV__
            debug = @debug or 0
            if debug
                console.log('pushRelatedChild()')

        node = @nodeMap[ref]
        that = this
        #console.log('  node=', node)

        slug_name = slug(node.name)
        #url = location.href.replace(/\/$/, "") + '/' + slug_name
        url = '/'
        if window['srm']['localhost']
            url += 'srm3.0/'
        url += 'methods-map/'
        url += slug_name
        #console.log('url=', url)

        name = node.name
        dx = 0
        dy = 0
        if @currentView is 'mobile'
            dx = 50
            dy = 40
        #console.log('  dx=', dx, 'dy=', dy)

        #
        # group
        #
        groupLayer = @relatedGroupLayer1.append('g')
            .attr('class', 'node')
            .attr('id', ref)
        if 0
            title = groupLayer.append('title')
                .text(name)

        #
        # lines
        #
        if @currentView isnt 'mobile'
            line = groupLayer.insert('line', 'circle')
            line
                .attr('class', 'sibling')
                .attr('null', (d, i) ->
                    #console.log(this)
                    this.ref = ref
                    this.circle = circle
                    this.groupLayer = groupLayer
                    return null
                )
                .attr('x2', dx)
                .attr('y2', dy)
                .on('click', (event) ->
                    #console.log('event=', event)
                    that.focusNode(this.ref)
                    return
                )

        #
        # bubbles
        #
        circle = groupLayer.append('circle')
        circle
            .attr('class', 'sibling')
            .attr('r', (d, i) ->
                #console.log(this)
                this.ref = ref
                this.circle = circle
                this.groupLayer = groupLayer
                if that.currentView is 'mobile'
                    this.radii = [3, 5]
                else
                    this.radii = [6, 8]
                return this.radii[0]
            )
            .attr('cx', dx)
            .attr('cy', dy)
            .attr('alt', () ->
                return name
            )
            .attr('aria-label', () ->
                return name
            )
            .on('click', (event) ->
                #console.log('event=', event)
                that.focusNode(this.ref)
                return
            )
            .on('mouseover', @toggleHover)
            .on('mouseout', @toggleHover)

        #
        # xlink
        #
        xlink = groupLayer.append('a')
            .attr('xlink:href', () ->
                if 0
                    # NOTE: moved above
                    slug_name = slug(node.name)
                    #url = location.href.replace(/\/$/, "") + '/' + slug_name
                    url = '/'
                    if window['srm']['localhost']
                        url += 'srm3.0/'
                    url += 'methods-map/'
                    url += slug_name
                    #console.log('url=', url)
                return url
            )
            .attr('null', (d, i) ->
                this.ref = ref
                this.circle = circle
                this.groupLayer = groupLayer
                return null
            )
            .on('click', (event) ->
                #console.log('event=', event)
                that.focusNode(this.ref)
                return
            )
            .on('mouseover', @toggleHover)
            .on('mouseout', @toggleHover)
        if @forceTabIndex
            xlink.attr('tabindex', tabindex)
        xlink.node().addEventListener('click', (event) ->
            # NOTE: needed to grab event, isn't passed in .on() above
            event.preventDefault()
            event.stopPropagation()
            return false
        )
        # NOTE: related
        xlink.node().addEventListener('keydown', (event) ->
            if event.which is 9 and not event.shiftKey and event.target.classList.contains('last-child')
                # NOTE: exiting bubbles into either history or outside svg if no history
                # NOTE: reset view
                that.focusBubble(null, event)
                return
        )
        xlink.node().addEventListener('keyup', (event) ->
            if event.which isnt 9
                return
            if 0
                console.log('focus related')
                console.log(event.target)
            if 0
                console.log('that.relatedGroup.classed("expanded")=', that.relatedGroup.classed('expanded'))
            if not that.relatedGroup.classed('expanded')
                if 1
                    that.toggleExpandedView(that.relatedGroup.node(), event, () =>
                        that.transitionInProgress = false
                        #if that.debugTransitions
                        #    console.log('  setting that.transitionInProgress to', JSON.stringify(that.transitionInProgress))
                        return
                    )
                else
                    that.focusBubble('related', event, () =>
                        # NOTE: when coming from narrower this focuses on a first stage view, terms are on bottom, must issue again to move terms to the right
                        that.focusBubble('related')
                        return
                    )

            return
        )

        #
        # text
        #
        #text = groupLayer.append('text')
        text = xlink.append('text')
        text
            .attr('class', 'sibling')
            .attr('null', (d, i) ->
                #console.log(this)
                this.ref = ref
                this.circle = circle
                this.groupLayer = groupLayer
                return null
            )
            .attr('x', dx)
            .attr('y', dy)
            #.on('click', () ->
            #    that.focusNode(this.ref)
            #    return
            #)
            #.on('mouseover', @toggleHover)
            #.on('mouseout', @toggleHover)
        text.append('tspan')
            .attr('class', 'name')
            .attr('null', (d, i) ->
                #console.log(this)
                this.ref = ref
                this.circle = circle
                this.groupLayer = groupLayer
                return null
            )
            .text(name)

        term = {title: name, href: url, ref: ref}
        #console.log('before adding', term, 'to @htmlRelatedBubbleTerms=', JSON.stringify(@htmlRelatedBubbleTerms, null, 2))
        @htmlRelatedBubbleTerms.push(term)
        #console.log('after adding @htmlRelatedBubbleTerms=', JSON.stringify(@htmlRelatedBubbleTerms, null, 2))

        return


module.exports = MapView
